import type { CountryProfileState, InternationalState, InternationalOrganizationState, InternationalAgreementState } from '../types/international.js';
import { governanceFlow } from './institutionSeed.js';

const REF='2026-09-18';
const countryFlow={...governanceFlow(['State Department','poste diplomatique','pays partenaire'],['Maison-Blanche','Commerce/USTR','Treasury','Defense','IC','Congrès','moteur international'],['international.monthly','diplomacy.action.resolve','agreement.review','travel.resolve'],['AGENCY_ACTION','SENATE_CONFIRMATION','CONGRESS_REQUIRED','SHARED_AUTHORITY'],'heures pour appels/notes; jours à mois pour négociations; mois/années pour accords'),historyStore:'international.history'};

const RAW_COUNTRIES = [
  {
    "id": "af",
    "iso2": "AF",
    "name": "Afghanistan",
    "capital": "Kabul",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 25
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 26.02,
    "economicIndex": 54,
    "militaryIndex": 48,
    "usTradeIndex": 53,
    "usAidIndex": 30,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 9,
    "relation": {
      "diplomatic": 52,
      "economic": 47,
      "military": 45,
      "intelligence": 72,
      "trust": 37,
      "foreignPublicOpinion": 65,
      "dependency": 40,
      "tension": 58
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-af",
      "countryId": "af",
      "label": "Mission américaine — Afghanistan",
      "status": "open",
      "city": "Kabul",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 66,
      "accessIndex": 61,
      "consularCapacityIndex": 76,
      "securityIndex": 56,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.75,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "al",
    "iso2": "AL",
    "name": "Albanie",
    "capital": "Tirana",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.9,
    "economicIndex": 66,
    "militaryIndex": 60,
    "usTradeIndex": 65,
    "usAidIndex": 42,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 64,
      "economic": 59,
      "military": 57,
      "intelligence": 35,
      "trust": 49,
      "foreignPublicOpinion": 28,
      "dependency": 52,
      "tension": 25
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO"
    ],
    "mission": {
      "id": "mission-al",
      "countryId": "al",
      "label": "Mission américaine — Albanie",
      "status": "open",
      "city": "Tirana",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 78,
      "accessIndex": 73,
      "consularCapacityIndex": 45,
      "securityIndex": 68,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "dz",
    "iso2": "DZ",
    "name": "Algérie",
    "capital": "Algiers",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 38.7,
    "economicIndex": 47,
    "militaryIndex": 30,
    "usTradeIndex": 27,
    "usAidIndex": 10,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 46,
      "economic": 41,
      "military": 39,
      "intelligence": 66,
      "trust": 31,
      "foreignPublicOpinion": 59,
      "dependency": 34,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-dz",
      "countryId": "dz",
      "label": "Mission américaine — Algérie",
      "status": "open",
      "city": "Algiers",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 52,
      "consularCapacityIndex": 76,
      "securityIndex": 50,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ad",
    "iso2": "AD",
    "name": "Andorre",
    "capital": "Non renseignée",
    "region": "Autre",
    "subregion": "Non renseignée",
    "stateBureau": "SPECIAL",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 50,
    "militaryIndex": 44,
    "usTradeIndex": 49,
    "usAidIndex": 26,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 5,
    "relation": {
      "diplomatic": 48,
      "economic": 43,
      "military": 41,
      "intelligence": 68,
      "trust": 33,
      "foreignPublicOpinion": 61,
      "dependency": 36,
      "tension": 54
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ad",
      "countryId": "ad",
      "label": "Mission américaine — Andorre",
      "status": "handling_post",
      "city": "Non renseignée",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 62,
      "accessIndex": 57,
      "consularCapacityIndex": 72,
      "securityIndex": 52,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ao",
    "iso2": "AO",
    "name": "Angola",
    "capital": "Luanda",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 43
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 24.38,
    "economicIndex": 72,
    "militaryIndex": 66,
    "usTradeIndex": 71,
    "usAidIndex": 48,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 27,
    "relation": {
      "diplomatic": 70,
      "economic": 65,
      "military": 63,
      "intelligence": 41,
      "trust": 55,
      "foreignPublicOpinion": 34,
      "dependency": 58,
      "tension": 31
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ao",
      "countryId": "ao",
      "label": "Mission américaine — Angola",
      "status": "open",
      "city": "Luanda",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 84,
      "accessIndex": 79,
      "consularCapacityIndex": 51,
      "securityIndex": 74,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.52,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ag",
    "iso2": "AG",
    "name": "Antigua-et-Barbuda",
    "capital": "Saint John's",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.09,
    "economicIndex": 56,
    "militaryIndex": 50,
    "usTradeIndex": 55,
    "usAidIndex": 32,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ag",
      "countryId": "ag",
      "label": "Mission américaine — Antigua-et-Barbuda",
      "status": "handling_post",
      "city": "Saint John's",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 68,
      "accessIndex": 63,
      "consularCapacityIndex": 78,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ar",
    "iso2": "AR",
    "name": "Argentine",
    "capital": "Buenos Aires",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 11
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 42.67,
    "economicIndex": 78,
    "militaryIndex": 72,
    "usTradeIndex": 77,
    "usAidIndex": 54,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 76,
      "economic": 71,
      "military": 69,
      "intelligence": 47,
      "trust": 61,
      "foreignPublicOpinion": 40,
      "dependency": 64,
      "tension": 37
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-ar",
      "countryId": "ar",
      "label": "Mission américaine — Argentine",
      "status": "open",
      "city": "Buenos Aires",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 53,
      "accessIndex": 85,
      "consularCapacityIndex": 57,
      "securityIndex": 80,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.58,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "am",
    "iso2": "AM",
    "name": "Arménie",
    "capital": "Yerevan",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.01,
    "economicIndex": 68,
    "militaryIndex": 62,
    "usTradeIndex": 67,
    "usAidIndex": 44,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 66,
      "economic": 61,
      "military": 59,
      "intelligence": 37,
      "trust": 51,
      "foreignPublicOpinion": 30,
      "dependency": 54,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-am",
      "countryId": "am",
      "label": "Mission américaine — Arménie",
      "status": "open",
      "city": "Yerevan",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 75,
      "consularCapacityIndex": 47,
      "securityIndex": 70,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.48,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "au",
    "iso2": "AU",
    "name": "Australie",
    "capital": "Canberra",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 23.7,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 33,
      "economic": 28,
      "military": 75,
      "intelligence": 53,
      "trust": 67,
      "foreignPublicOpinion": 46,
      "dependency": 70,
      "tension": 43
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Alliance / traité de sécurité US"
    ],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-au",
      "countryId": "au",
      "label": "Mission américaine — Australie",
      "status": "open",
      "city": "Canberra",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "at",
    "iso2": "AT",
    "name": "Autriche",
    "capital": "Vienna",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 8.53,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "UE"
    ],
    "mission": {
      "id": "mission-at",
      "countryId": "at",
      "label": "Mission américaine — Autriche",
      "status": "open",
      "city": "Vienna",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "az",
    "iso2": "AZ",
    "name": "Azerbaïdjan",
    "capital": "Baku",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.55,
    "economicIndex": 44,
    "militaryIndex": 27,
    "usTradeIndex": 24,
    "usAidIndex": 7,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 43,
      "economic": 38,
      "military": 36,
      "intelligence": 63,
      "trust": 28,
      "foreignPublicOpinion": 56,
      "dependency": 31,
      "tension": 53
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-az",
      "countryId": "az",
      "label": "Mission américaine — Azerbaïdjan",
      "status": "open",
      "city": "Baku",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 49,
      "consularCapacityIndex": 73,
      "securityIndex": 47,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.74,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bs",
    "iso2": "BS",
    "name": "Bahamas",
    "capital": "Nassau",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 14
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.32,
    "economicIndex": 81,
    "militaryIndex": 75,
    "usTradeIndex": 80,
    "usAidIndex": 57,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 30,
      "economic": 74,
      "military": 72,
      "intelligence": 50,
      "trust": 64,
      "foreignPublicOpinion": 43,
      "dependency": 67,
      "tension": 40
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bs",
      "countryId": "bs",
      "label": "Mission américaine — Bahamas",
      "status": "open",
      "city": "Nassau",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 56,
      "accessIndex": 36,
      "consularCapacityIndex": 60,
      "securityIndex": 83,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.61,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bh",
    "iso2": "BH",
    "name": "Bahreïn",
    "capital": "Manama",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.32,
    "economicIndex": 59,
    "militaryIndex": 53,
    "usTradeIndex": 58,
    "usAidIndex": 35,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 57,
      "economic": 52,
      "military": 50,
      "intelligence": 28,
      "trust": 42,
      "foreignPublicOpinion": 70,
      "dependency": 45,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bh",
      "countryId": "bh",
      "label": "Mission américaine — Bahreïn",
      "status": "open",
      "city": "Manama",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 71,
      "accessIndex": 66,
      "consularCapacityIndex": 81,
      "securityIndex": 61,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bd",
    "iso2": "BD",
    "name": "Bangladesh",
    "capital": "Dhaka",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 22
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 157.49,
    "economicIndex": 51,
    "militaryIndex": 45,
    "usTradeIndex": 50,
    "usAidIndex": 27,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 6,
    "relation": {
      "diplomatic": 49,
      "economic": 44,
      "military": 42,
      "intelligence": 69,
      "trust": 34,
      "foreignPublicOpinion": 62,
      "dependency": 37,
      "tension": 55
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bd",
      "countryId": "bd",
      "label": "Mission américaine — Bangladesh",
      "status": "open",
      "city": "Dhaka",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 58,
      "consularCapacityIndex": 73,
      "securityIndex": 53,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.72,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bb",
    "iso2": "BB",
    "name": "Barbade",
    "capital": "Bridgetown",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 18
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.28,
    "economicIndex": 47,
    "militaryIndex": 41,
    "usTradeIndex": 46,
    "usAidIndex": 23,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 45,
      "economic": 40,
      "military": 38,
      "intelligence": 65,
      "trust": 30,
      "foreignPublicOpinion": 58,
      "dependency": 33,
      "tension": 51
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bb",
      "countryId": "bb",
      "label": "Mission américaine — Barbade",
      "status": "open",
      "city": "Bridgetown",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 54,
      "consularCapacityIndex": 69,
      "securityIndex": 49,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "by",
    "iso2": "BY",
    "name": "Biélorussie",
    "capital": "Minsk",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.48,
    "economicIndex": 43,
    "militaryIndex": 26,
    "usTradeIndex": 23,
    "usAidIndex": 6,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 42,
      "economic": 37,
      "military": 35,
      "intelligence": 62,
      "trust": 76,
      "foreignPublicOpinion": 55,
      "dependency": 30,
      "tension": 52
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-by",
      "countryId": "by",
      "label": "Mission américaine — Biélorussie",
      "status": "open",
      "city": "Minsk",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 48,
      "consularCapacityIndex": 72,
      "securityIndex": 46,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "be",
    "iso2": "BE",
    "name": "Belgique",
    "capital": "Brussels",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 11.23,
    "economicIndex": 53,
    "militaryIndex": 47,
    "usTradeIndex": 52,
    "usAidIndex": 29,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 51,
      "economic": 46,
      "military": 44,
      "intelligence": 71,
      "trust": 36,
      "foreignPublicOpinion": 64,
      "dependency": 39,
      "tension": 57
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-be",
      "countryId": "be",
      "label": "Mission américaine — Belgique",
      "status": "open",
      "city": "Brussels",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 65,
      "accessIndex": 60,
      "consularCapacityIndex": 75,
      "securityIndex": 55,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.74,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bz",
    "iso2": "BZ",
    "name": "Belize",
    "capital": "Belmopan",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.35,
    "economicIndex": 45,
    "militaryIndex": 28,
    "usTradeIndex": 25,
    "usAidIndex": 8,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 44,
      "economic": 39,
      "military": 37,
      "intelligence": 64,
      "trust": 29,
      "foreignPublicOpinion": 57,
      "dependency": 32,
      "tension": 54
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bz",
      "countryId": "bz",
      "label": "Mission américaine — Belize",
      "status": "open",
      "city": "Belmopan",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 50,
      "consularCapacityIndex": 74,
      "securityIndex": 48,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.75,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bj",
    "iso2": "BJ",
    "name": "Bénin",
    "capital": "Porto-Novo",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 34
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.99,
    "economicIndex": 63,
    "militaryIndex": 57,
    "usTradeIndex": 62,
    "usAidIndex": 39,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 18,
    "relation": {
      "diplomatic": 61,
      "economic": 56,
      "military": 54,
      "intelligence": 32,
      "trust": 46,
      "foreignPublicOpinion": 74,
      "dependency": 49,
      "tension": 22
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bj",
      "countryId": "bj",
      "label": "Mission américaine — Bénin",
      "status": "open",
      "city": "Porto-Novo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 75,
      "accessIndex": 70,
      "consularCapacityIndex": 42,
      "securityIndex": 65,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.84,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bt",
    "iso2": "BT",
    "name": "Bhoutan",
    "capital": "Thimphu",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 16
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.76,
    "economicIndex": 83,
    "militaryIndex": 77,
    "usTradeIndex": 13,
    "usAidIndex": 59,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 9,
    "relation": {
      "diplomatic": 32,
      "economic": 76,
      "military": 74,
      "intelligence": 52,
      "trust": 66,
      "foreignPublicOpinion": 45,
      "dependency": 69,
      "tension": 42
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bt",
      "countryId": "bt",
      "label": "Mission américaine — Bhoutan",
      "status": "open",
      "city": "Thimphu",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 58,
      "accessIndex": 38,
      "consularCapacityIndex": 62,
      "securityIndex": 85,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.63,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bo",
    "iso2": "BO",
    "name": "Bolivie",
    "capital": "Sucre",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 44
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.03,
    "economicIndex": 73,
    "militaryIndex": 67,
    "usTradeIndex": 72,
    "usAidIndex": 49,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 71,
      "economic": 66,
      "military": 64,
      "intelligence": 42,
      "trust": 56,
      "foreignPublicOpinion": 35,
      "dependency": 59,
      "tension": 32
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bo",
      "countryId": "bo",
      "label": "Mission américaine — Bolivie",
      "status": "open",
      "city": "Sucre",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 80,
      "consularCapacityIndex": 52,
      "securityIndex": 75,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ba",
    "iso2": "BA",
    "name": "Bosnie-Herzégovine",
    "capital": "Sarajevo",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 16
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.79,
    "economicIndex": 45,
    "militaryIndex": 39,
    "usTradeIndex": 44,
    "usAidIndex": 21,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 43,
      "economic": 38,
      "military": 36,
      "intelligence": 63,
      "trust": 28,
      "foreignPublicOpinion": 56,
      "dependency": 31,
      "tension": 49
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ba",
      "countryId": "ba",
      "label": "Mission américaine — Bosnie-Herzégovine",
      "status": "open",
      "city": "Sarajevo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 52,
      "consularCapacityIndex": 67,
      "securityIndex": 47,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.66,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bw",
    "iso2": "BW",
    "name": "Botswana",
    "capital": "Gaborone",
    "region": "Africa",
    "subregion": "Southern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 22
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.02,
    "economicIndex": 39,
    "militaryIndex": 22,
    "usTradeIndex": 19,
    "usAidIndex": 2,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 38,
      "economic": 33,
      "military": 31,
      "intelligence": 58,
      "trust": 72,
      "foreignPublicOpinion": 51,
      "dependency": 75,
      "tension": 48
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bw",
      "countryId": "bw",
      "label": "Mission américaine — Botswana",
      "status": "open",
      "city": "Gaborone",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 44,
      "consularCapacityIndex": 68,
      "securityIndex": 42,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.69,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "br",
    "iso2": "BR",
    "name": "Brésil",
    "capital": "Brasília",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 12
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 203.59,
    "economicIndex": 79,
    "militaryIndex": 73,
    "usTradeIndex": 78,
    "usAidIndex": 55,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 5,
    "relation": {
      "diplomatic": 28,
      "economic": 72,
      "military": 70,
      "intelligence": 48,
      "trust": 62,
      "foreignPublicOpinion": 41,
      "dependency": 65,
      "tension": 38
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-br",
      "countryId": "br",
      "label": "Mission américaine — Brésil",
      "status": "open",
      "city": "Brasília",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 54,
      "accessIndex": 86,
      "consularCapacityIndex": 58,
      "securityIndex": 81,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.59,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bn",
    "iso2": "BN",
    "name": "Brunei",
    "capital": "Bandar Seri Begawan",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 42
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.39,
    "economicIndex": 71,
    "militaryIndex": 65,
    "usTradeIndex": 70,
    "usAidIndex": 47,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 69,
      "economic": 64,
      "military": 62,
      "intelligence": 40,
      "trust": 54,
      "foreignPublicOpinion": 33,
      "dependency": 57,
      "tension": 30
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bn",
      "countryId": "bn",
      "label": "Mission américaine — Brunei",
      "status": "open",
      "city": "Bandar Seri Begawan",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 83,
      "accessIndex": 78,
      "consularCapacityIndex": 50,
      "securityIndex": 73,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bg",
    "iso2": "BG",
    "name": "Bulgarie",
    "capital": "Sofia",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 7.25,
    "economicIndex": 57,
    "militaryIndex": 51,
    "usTradeIndex": 56,
    "usAidIndex": 33,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 55,
      "economic": 50,
      "military": 48,
      "intelligence": 75,
      "trust": 40,
      "foreignPublicOpinion": 68,
      "dependency": 43,
      "tension": 61
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-bg",
      "countryId": "bg",
      "label": "Mission américaine — Bulgarie",
      "status": "open",
      "city": "Sofia",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 64,
      "consularCapacityIndex": 79,
      "securityIndex": 59,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bf",
    "iso2": "BF",
    "name": "Burkina Faso",
    "capital": "Ouagadougou",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 17.32,
    "economicIndex": 55,
    "militaryIndex": 49,
    "usTradeIndex": 54,
    "usAidIndex": 31,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bf",
      "countryId": "bf",
      "label": "Mission américaine — Burkina Faso",
      "status": "open",
      "city": "Ouagadougou",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 67,
      "accessIndex": 62,
      "consularCapacityIndex": 77,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "bi",
    "iso2": "BI",
    "name": "Burundi",
    "capital": "Bujumbura",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 32
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.53,
    "economicIndex": 61,
    "militaryIndex": 55,
    "usTradeIndex": 60,
    "usAidIndex": 37,
    "sanctionsLevel": 18,
    "usBaseAccessIndex": 16,
    "relation": {
      "diplomatic": 59,
      "economic": 54,
      "military": 52,
      "intelligence": 30,
      "trust": 44,
      "foreignPublicOpinion": 72,
      "dependency": 47,
      "tension": 20
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-bi",
      "countryId": "bi",
      "label": "Mission américaine — Burundi",
      "status": "open",
      "city": "Bujumbura",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 73,
      "accessIndex": 68,
      "consularCapacityIndex": 83,
      "securityIndex": 63,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.82,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cv",
    "iso2": "CV",
    "name": "Cabo Verde",
    "capital": "Praia",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.52,
    "economicIndex": 38,
    "militaryIndex": 21,
    "usTradeIndex": 18,
    "usAidIndex": 1,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 37,
      "economic": 32,
      "military": 30,
      "intelligence": 57,
      "trust": 71,
      "foreignPublicOpinion": 50,
      "dependency": 74,
      "tension": 47
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cv",
      "countryId": "cv",
      "label": "Mission américaine — Cabo Verde",
      "status": "open",
      "city": "Praia",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 43,
      "consularCapacityIndex": 67,
      "securityIndex": 41,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kh",
    "iso2": "KH",
    "name": "Cambodge",
    "capital": "Phnom Penh",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.18,
    "economicIndex": 68,
    "militaryIndex": 62,
    "usTradeIndex": 67,
    "usAidIndex": 44,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 66,
      "economic": 61,
      "military": 59,
      "intelligence": 37,
      "trust": 51,
      "foreignPublicOpinion": 30,
      "dependency": 54,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kh",
      "countryId": "kh",
      "label": "Mission américaine — Cambodge",
      "status": "open",
      "city": "Phnom Penh",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 75,
      "consularCapacityIndex": 47,
      "securityIndex": 70,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.48,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cm",
    "iso2": "CM",
    "name": "Cameroun",
    "capital": "Yaoundé",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 41
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 20.39,
    "economicIndex": 70,
    "militaryIndex": 64,
    "usTradeIndex": 69,
    "usAidIndex": 46,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 25,
    "relation": {
      "diplomatic": 68,
      "economic": 63,
      "military": 61,
      "intelligence": 39,
      "trust": 53,
      "foreignPublicOpinion": 32,
      "dependency": 56,
      "tension": 29
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cm",
      "countryId": "cm",
      "label": "Mission américaine — Cameroun",
      "status": "open",
      "city": "Yaoundé",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 82,
      "accessIndex": 77,
      "consularCapacityIndex": 49,
      "securityIndex": 72,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.5,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ca",
    "iso2": "CA",
    "name": "Canada",
    "capital": "Ottawa",
    "region": "Americas",
    "subregion": "Northern America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 35.54,
    "economicIndex": 46,
    "militaryIndex": 40,
    "usTradeIndex": 72,
    "usAidIndex": 22,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 92,
      "economic": 94,
      "military": 88,
      "intelligence": 88,
      "trust": 86,
      "foreignPublicOpinion": 72,
      "dependency": 86,
      "tension": 16
    },
    "dependencies": [
      "énergie",
      "minerais critiques",
      "automobile",
      "agriculture"
    ],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "G7",
      "G20"
    ],
    "mission": {
      "id": "mission-ca",
      "countryId": "ca",
      "label": "Mission américaine — Canada",
      "status": "open",
      "city": "Ottawa",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 58,
      "accessIndex": 53,
      "consularCapacityIndex": 68,
      "securityIndex": 48,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.67,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cf",
    "iso2": "CF",
    "name": "République centrafricaine",
    "capital": "Bangui",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.71,
    "economicIndex": 56,
    "militaryIndex": 50,
    "usTradeIndex": 55,
    "usAidIndex": 32,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cf",
      "countryId": "cf",
      "label": "Mission américaine — République centrafricaine",
      "status": "open",
      "city": "Bangui",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 63,
      "consularCapacityIndex": 78,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "td",
    "iso2": "TD",
    "name": "Tchad",
    "capital": "N'Djamena",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 13.21,
    "economicIndex": 69,
    "militaryIndex": 63,
    "usTradeIndex": 68,
    "usAidIndex": 45,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 67,
      "economic": 62,
      "military": 60,
      "intelligence": 38,
      "trust": 52,
      "foreignPublicOpinion": 31,
      "dependency": 55,
      "tension": 28
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-td",
      "countryId": "td",
      "label": "Mission américaine — Tchad",
      "status": "open",
      "city": "N'Djamena",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 81,
      "accessIndex": 76,
      "consularCapacityIndex": 48,
      "securityIndex": 71,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.49,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cl",
    "iso2": "CL",
    "name": "Chili",
    "capital": "Santiago",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 17.82,
    "economicIndex": 68,
    "militaryIndex": 62,
    "usTradeIndex": 67,
    "usAidIndex": 44,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 66,
      "economic": 61,
      "military": 59,
      "intelligence": 37,
      "trust": 51,
      "foreignPublicOpinion": 30,
      "dependency": 54,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cl",
      "countryId": "cl",
      "label": "Mission américaine — Chili",
      "status": "open",
      "city": "Santiago",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 75,
      "consularCapacityIndex": 47,
      "securityIndex": 70,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.48,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cn",
    "iso2": "CN",
    "name": "Chine",
    "capital": "Beijing",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Xi Jinping",
      "title": "Président de la République populaire de Chine",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Ministère chinois des Affaires étrangères — 12/09/2026",
      "successionRiskIndex": 18
    },
    "regimeLabel": "République populaire à parti unique",
    "populationMillions": 1367.11,
    "economicIndex": 72,
    "militaryIndex": 66,
    "usTradeIndex": 72,
    "usAidIndex": 48,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 27,
    "relation": {
      "diplomatic": 42,
      "economic": 62,
      "military": 22,
      "intelligence": 18,
      "trust": 26,
      "foreignPublicOpinion": 38,
      "dependency": 68,
      "tension": 72
    },
    "dependencies": [
      "électronique",
      "batteries",
      "terres rares",
      "biens manufacturés"
    ],
    "disputes": [
      "Technologie et contrôles export",
      "Mer de Chine / sécurité régionale",
      "Taïwan et stabilité du détroit",
      "Accès au marché et pratiques commerciales"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20",
      "CSNU-P5"
    ],
    "mission": {
      "id": "mission-cn",
      "countryId": "cn",
      "label": "Mission américaine — Chine",
      "status": "open",
      "city": "Beijing",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 84,
      "accessIndex": 79,
      "consularCapacityIndex": 51,
      "securityIndex": 74,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.52,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "co",
    "iso2": "CO",
    "name": "Colombie",
    "capital": "Bogotá",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 45
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 47.91,
    "economicIndex": 74,
    "militaryIndex": 68,
    "usTradeIndex": 73,
    "usAidIndex": 50,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 72,
      "economic": 67,
      "military": 65,
      "intelligence": 43,
      "trust": 57,
      "foreignPublicOpinion": 36,
      "dependency": 60,
      "tension": 33
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-co",
      "countryId": "co",
      "label": "Mission américaine — Colombie",
      "status": "open",
      "city": "Bogotá",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 49,
      "accessIndex": 81,
      "consularCapacityIndex": 53,
      "securityIndex": 76,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.54,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "km",
    "iso2": "KM",
    "name": "Comores",
    "capital": "Moroni",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 11
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.76,
    "economicIndex": 78,
    "militaryIndex": 72,
    "usTradeIndex": 77,
    "usAidIndex": 54,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 76,
      "economic": 71,
      "military": 69,
      "intelligence": 47,
      "trust": 61,
      "foreignPublicOpinion": 40,
      "dependency": 64,
      "tension": 37
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-km",
      "countryId": "km",
      "label": "Mission américaine — Comores",
      "status": "handling_post",
      "city": "Moroni",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 53,
      "accessIndex": 85,
      "consularCapacityIndex": 57,
      "securityIndex": 80,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.58,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cg",
    "iso2": "CG",
    "name": "République du Congo",
    "capital": "Brazzaville",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.56,
    "economicIndex": 58,
    "militaryIndex": 52,
    "usTradeIndex": 57,
    "usAidIndex": 34,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 56,
      "economic": 51,
      "military": 49,
      "intelligence": 76,
      "trust": 41,
      "foreignPublicOpinion": 69,
      "dependency": 44,
      "tension": 62
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cg",
      "countryId": "cg",
      "label": "Mission américaine — République du Congo",
      "status": "open",
      "city": "Brazzaville",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 65,
      "consularCapacityIndex": 80,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.79,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cd",
    "iso2": "CD",
    "name": "République démocratique du Congo",
    "capital": "Kinshasa",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 69.36,
    "economicIndex": 52,
    "militaryIndex": 46,
    "usTradeIndex": 51,
    "usAidIndex": 28,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 50,
      "economic": 45,
      "military": 43,
      "intelligence": 70,
      "trust": 35,
      "foreignPublicOpinion": 63,
      "dependency": 38,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cd",
      "countryId": "cd",
      "label": "Mission américaine — République démocratique du Congo",
      "status": "open",
      "city": "Kinshasa",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 59,
      "consularCapacityIndex": 74,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cr",
    "iso2": "CR",
    "name": "Costa Rica",
    "capital": "San José",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 13
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.71,
    "economicIndex": 80,
    "militaryIndex": 74,
    "usTradeIndex": 79,
    "usAidIndex": 56,
    "sanctionsLevel": 18,
    "usBaseAccessIndex": 6,
    "relation": {
      "diplomatic": 29,
      "economic": 73,
      "military": 71,
      "intelligence": 49,
      "trust": 63,
      "foreignPublicOpinion": 42,
      "dependency": 66,
      "tension": 39
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cr",
      "countryId": "cr",
      "label": "Mission américaine — Costa Rica",
      "status": "open",
      "city": "San José",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 55,
      "accessIndex": 35,
      "consularCapacityIndex": 59,
      "securityIndex": 82,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.6,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ci",
    "iso2": "CI",
    "name": "Côte d’Ivoire",
    "capital": "Yamoussoukro",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 23.82,
    "economicIndex": 62,
    "militaryIndex": 56,
    "usTradeIndex": 61,
    "usAidIndex": 38,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 60,
      "economic": 55,
      "military": 53,
      "intelligence": 31,
      "trust": 45,
      "foreignPublicOpinion": 73,
      "dependency": 48,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ci",
      "countryId": "ci",
      "label": "Mission américaine — Côte d’Ivoire",
      "status": "open",
      "city": "Yamoussoukro",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 74,
      "accessIndex": 69,
      "consularCapacityIndex": 84,
      "securityIndex": 64,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "hr",
    "iso2": "HR",
    "name": "Croatie",
    "capital": "Zagreb",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 18
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.27,
    "economicIndex": 35,
    "militaryIndex": 79,
    "usTradeIndex": 15,
    "usAidIndex": 61,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 34,
      "economic": 29,
      "military": 76,
      "intelligence": 54,
      "trust": 68,
      "foreignPublicOpinion": 47,
      "dependency": 71,
      "tension": 44
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-hr",
      "countryId": "hr",
      "label": "Mission américaine — Croatie",
      "status": "open",
      "city": "Zagreb",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 60,
      "accessIndex": 40,
      "consularCapacityIndex": 64,
      "securityIndex": 87,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.65,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cu",
    "iso2": "CU",
    "name": "Cuba",
    "capital": "Havana",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 19
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 11.21,
    "economicIndex": 36,
    "militaryIndex": 80,
    "usTradeIndex": 16,
    "usAidIndex": 62,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 35,
      "economic": 30,
      "military": 28,
      "intelligence": 55,
      "trust": 69,
      "foreignPublicOpinion": 48,
      "dependency": 72,
      "tension": 45
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-cu",
      "countryId": "cu",
      "label": "Mission américaine — Cuba",
      "status": "open",
      "city": "Havana",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 61,
      "accessIndex": 41,
      "consularCapacityIndex": 65,
      "securityIndex": 88,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.66,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cy",
    "iso2": "CY",
    "name": "Chypre",
    "capital": "Nicosia",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.86,
    "economicIndex": 44,
    "militaryIndex": 27,
    "usTradeIndex": 24,
    "usAidIndex": 7,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 43,
      "economic": 38,
      "military": 36,
      "intelligence": 63,
      "trust": 28,
      "foreignPublicOpinion": 56,
      "dependency": 31,
      "tension": 53
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "UE"
    ],
    "mission": {
      "id": "mission-cy",
      "countryId": "cy",
      "label": "Mission américaine — Chypre",
      "status": "open",
      "city": "Nicosia",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 49,
      "consularCapacityIndex": 73,
      "securityIndex": 47,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.74,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "cz",
    "iso2": "CZ",
    "name": "Tchéquie",
    "capital": "Prague",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.52,
    "economicIndex": 46,
    "militaryIndex": 29,
    "usTradeIndex": 26,
    "usAidIndex": 9,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 45,
      "economic": 40,
      "military": 38,
      "intelligence": 65,
      "trust": 30,
      "foreignPublicOpinion": 58,
      "dependency": 33,
      "tension": 55
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-cz",
      "countryId": "cz",
      "label": "Mission américaine — Tchéquie",
      "status": "open",
      "city": "Prague",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 71,
      "accessIndex": 51,
      "consularCapacityIndex": 75,
      "securityIndex": 49,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kp",
    "iso2": "KP",
    "name": "Corée du Nord",
    "capital": "Pyongyang",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 25.03,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 98,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 8,
      "economic": 4,
      "military": 4,
      "intelligence": 5,
      "trust": 4,
      "foreignPublicOpinion": 15,
      "dependency": 5,
      "tension": 92
    },
    "dependencies": [],
    "disputes": [
      "Programme nucléaire et missiles",
      "Sanctions multilatérales",
      "Sécurité de la péninsule coréenne"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kp",
      "countryId": "kp",
      "label": "Mission américaine — Corée du Nord",
      "status": "no_relations",
      "city": "Pyongyang",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "dk",
    "iso2": "DK",
    "name": "Danemark",
    "capital": "Copenhagen",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.66,
    "economicIndex": 67,
    "militaryIndex": 61,
    "usTradeIndex": 66,
    "usAidIndex": 43,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 65,
      "economic": 60,
      "military": 58,
      "intelligence": 36,
      "trust": 50,
      "foreignPublicOpinion": 29,
      "dependency": 53,
      "tension": 26
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-dk",
      "countryId": "dk",
      "label": "Mission américaine — Danemark",
      "status": "open",
      "city": "Copenhagen",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 74,
      "consularCapacityIndex": 46,
      "securityIndex": 69,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.88,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "dj",
    "iso2": "DJ",
    "name": "Djibouti",
    "capital": "Djibouti",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.89,
    "economicIndex": 65,
    "militaryIndex": 59,
    "usTradeIndex": 64,
    "usAidIndex": 41,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 63,
      "economic": 58,
      "military": 56,
      "intelligence": 34,
      "trust": 48,
      "foreignPublicOpinion": 76,
      "dependency": 51,
      "tension": 24
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-dj",
      "countryId": "dj",
      "label": "Mission américaine — Djibouti",
      "status": "open",
      "city": "Djibouti",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 72,
      "consularCapacityIndex": 44,
      "securityIndex": 67,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.86,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "dm",
    "iso2": "DM",
    "name": "Dominique",
    "capital": "Roseau",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 42
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.07,
    "economicIndex": 71,
    "militaryIndex": 65,
    "usTradeIndex": 70,
    "usAidIndex": 47,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 69,
      "economic": 64,
      "military": 62,
      "intelligence": 40,
      "trust": 54,
      "foreignPublicOpinion": 33,
      "dependency": 57,
      "tension": 30
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-dm",
      "countryId": "dm",
      "label": "Mission américaine — Dominique",
      "status": "handling_post",
      "city": "Roseau",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 83,
      "accessIndex": 78,
      "consularCapacityIndex": 50,
      "securityIndex": 73,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "do",
    "iso2": "DO",
    "name": "République dominicaine",
    "capital": "Santo Domingo",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 8
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.38,
    "economicIndex": 75,
    "militaryIndex": 69,
    "usTradeIndex": 74,
    "usAidIndex": 51,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 73,
      "economic": 68,
      "military": 66,
      "intelligence": 44,
      "trust": 58,
      "foreignPublicOpinion": 37,
      "dependency": 61,
      "tension": 34
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-do",
      "countryId": "do",
      "label": "Mission américaine — République dominicaine",
      "status": "open",
      "city": "Santo Domingo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 50,
      "accessIndex": 82,
      "consularCapacityIndex": 54,
      "securityIndex": 77,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.55,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ec",
    "iso2": "EC",
    "name": "Équateur",
    "capital": "Quito",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.89,
    "economicIndex": 52,
    "militaryIndex": 46,
    "usTradeIndex": 51,
    "usAidIndex": 28,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 50,
      "economic": 45,
      "military": 43,
      "intelligence": 70,
      "trust": 35,
      "foreignPublicOpinion": 63,
      "dependency": 38,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ec",
      "countryId": "ec",
      "label": "Mission américaine — Équateur",
      "status": "open",
      "city": "Quito",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 59,
      "consularCapacityIndex": 74,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "eg",
    "iso2": "EG",
    "name": "Égypte",
    "capital": "Cairo",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 87.67,
    "economicIndex": 60,
    "militaryIndex": 54,
    "usTradeIndex": 59,
    "usAidIndex": 36,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 58,
      "economic": 53,
      "military": 51,
      "intelligence": 29,
      "trust": 43,
      "foreignPublicOpinion": 71,
      "dependency": 46,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-eg",
      "countryId": "eg",
      "label": "Mission américaine — Égypte",
      "status": "open",
      "city": "Cairo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 67,
      "consularCapacityIndex": 82,
      "securityIndex": 62,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sv",
    "iso2": "SV",
    "name": "Salvador",
    "capital": "San Salvador",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.4,
    "economicIndex": 54,
    "militaryIndex": 37,
    "usTradeIndex": 34,
    "usAidIndex": 17,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sv",
      "countryId": "sv",
      "label": "Mission américaine — Salvador",
      "status": "open",
      "city": "San Salvador",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 59,
      "consularCapacityIndex": 83,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.84,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gq",
    "iso2": "GQ",
    "name": "Guinée équatoriale",
    "capital": "Malabo",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.43,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gq",
      "countryId": "gq",
      "label": "Mission américaine — Guinée équatoriale",
      "status": "open",
      "city": "Malabo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "er",
    "iso2": "ER",
    "name": "Érythrée",
    "capital": "Asmara",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.54,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-er",
      "countryId": "er",
      "label": "Mission américaine — Érythrée",
      "status": "open",
      "city": "Asmara",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ee",
    "iso2": "EE",
    "name": "Estonie",
    "capital": "Tallinn",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.32,
    "economicIndex": 56,
    "militaryIndex": 50,
    "usTradeIndex": 55,
    "usAidIndex": 32,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-ee",
      "countryId": "ee",
      "label": "Mission américaine — Estonie",
      "status": "open",
      "city": "Tallinn",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 63,
      "consularCapacityIndex": 78,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sz",
    "iso2": "SZ",
    "name": "Eswatini",
    "capital": "Lobamba",
    "region": "Africa",
    "subregion": "Southern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 45
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.11,
    "economicIndex": 62,
    "militaryIndex": 45,
    "usTradeIndex": 42,
    "usAidIndex": 25,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 9,
    "relation": {
      "diplomatic": 61,
      "economic": 56,
      "military": 54,
      "intelligence": 32,
      "trust": 46,
      "foreignPublicOpinion": 74,
      "dependency": 49,
      "tension": 26
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sz",
      "countryId": "sz",
      "label": "Mission américaine — Eswatini",
      "status": "open",
      "city": "Lobamba",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 50,
      "accessIndex": 67,
      "consularCapacityIndex": 48,
      "securityIndex": 65,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "et",
    "iso2": "ET",
    "name": "Éthiopie",
    "capital": "Addis Ababa",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 19
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 87.95,
    "economicIndex": 36,
    "militaryIndex": 80,
    "usTradeIndex": 16,
    "usAidIndex": 62,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 35,
      "economic": 30,
      "military": 28,
      "intelligence": 55,
      "trust": 69,
      "foreignPublicOpinion": 48,
      "dependency": 72,
      "tension": 45
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-et",
      "countryId": "et",
      "label": "Mission américaine — Éthiopie",
      "status": "open",
      "city": "Addis Ababa",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 61,
      "accessIndex": 41,
      "consularCapacityIndex": 65,
      "securityIndex": 88,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.66,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "fj",
    "iso2": "FJ",
    "name": "Fidji",
    "capital": "Suva",
    "region": "Oceania",
    "subregion": "Melanesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.86,
    "economicIndex": 67,
    "militaryIndex": 61,
    "usTradeIndex": 66,
    "usAidIndex": 43,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 65,
      "economic": 60,
      "military": 58,
      "intelligence": 36,
      "trust": 50,
      "foreignPublicOpinion": 29,
      "dependency": 53,
      "tension": 26
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-fj",
      "countryId": "fj",
      "label": "Mission américaine — Fidji",
      "status": "open",
      "city": "Suva",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 74,
      "consularCapacityIndex": 46,
      "securityIndex": 69,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.88,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "fi",
    "iso2": "FI",
    "name": "Finlande",
    "capital": "Helsinki",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.47,
    "economicIndex": 65,
    "militaryIndex": 59,
    "usTradeIndex": 64,
    "usAidIndex": 41,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 63,
      "economic": 58,
      "military": 56,
      "intelligence": 34,
      "trust": 48,
      "foreignPublicOpinion": 76,
      "dependency": 51,
      "tension": 24
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-fi",
      "countryId": "fi",
      "label": "Mission américaine — Finlande",
      "status": "open",
      "city": "Helsinki",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 72,
      "consularCapacityIndex": 44,
      "securityIndex": 67,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.86,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "fr",
    "iso2": "FR",
    "name": "France",
    "capital": "Paris",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Emmanuel Macron",
      "title": "Président de la République",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Élysée — fiche du Président, consultée 18/09/2026",
      "successionRiskIndex": 14
    },
    "regimeLabel": "République semi-présidentielle",
    "populationMillions": 66.08,
    "economicIndex": 83,
    "militaryIndex": 77,
    "usTradeIndex": 72,
    "usAidIndex": 59,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 9,
    "relation": {
      "diplomatic": 88,
      "economic": 82,
      "military": 86,
      "intelligence": 78,
      "trust": 80,
      "foreignPublicOpinion": 64,
      "dependency": 50,
      "tension": 22
    },
    "dependencies": [
      "aéronautique",
      "pharma",
      "énergie nucléaire",
      "services"
    ],
    "disputes": [
      "Coordination OTAN/UE",
      "Commerce et régulation technologique",
      "Sahel/Afrique et Moyen-Orient",
      "Climat et diplomatie économique"
    ],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE",
      "G7",
      "G20",
      "CSNU-P5"
    ],
    "mission": {
      "id": "mission-fr",
      "countryId": "fr",
      "label": "Mission américaine — France",
      "status": "open",
      "city": "Paris",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 58,
      "accessIndex": 38,
      "consularCapacityIndex": 62,
      "securityIndex": 85,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.63,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ga",
    "iso2": "GA",
    "name": "Gabon",
    "capital": "Libreville",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.71,
    "economicIndex": 50,
    "militaryIndex": 44,
    "usTradeIndex": 49,
    "usAidIndex": 26,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 5,
    "relation": {
      "diplomatic": 48,
      "economic": 43,
      "military": 41,
      "intelligence": 68,
      "trust": 33,
      "foreignPublicOpinion": 61,
      "dependency": 36,
      "tension": 54
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ga",
      "countryId": "ga",
      "label": "Mission américaine — Gabon",
      "status": "open",
      "city": "Libreville",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 62,
      "accessIndex": 57,
      "consularCapacityIndex": 72,
      "securityIndex": 52,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gm",
    "iso2": "GM",
    "name": "Gambie",
    "capital": "Banjul",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 45
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.88,
    "economicIndex": 74,
    "militaryIndex": 68,
    "usTradeIndex": 73,
    "usAidIndex": 50,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 72,
      "economic": 67,
      "military": 65,
      "intelligence": 43,
      "trust": 57,
      "foreignPublicOpinion": 36,
      "dependency": 60,
      "tension": 33
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gm",
      "countryId": "gm",
      "label": "Mission américaine — Gambie",
      "status": "open",
      "city": "Banjul",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 49,
      "accessIndex": 81,
      "consularCapacityIndex": 53,
      "securityIndex": 76,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.54,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ge",
    "iso2": "GE",
    "name": "Géorgie",
    "capital": "Tbilisi",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.49,
    "economicIndex": 58,
    "militaryIndex": 52,
    "usTradeIndex": 57,
    "usAidIndex": 34,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 56,
      "economic": 51,
      "military": 49,
      "intelligence": 76,
      "trust": 41,
      "foreignPublicOpinion": 69,
      "dependency": 44,
      "tension": 62
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ge",
      "countryId": "ge",
      "label": "Mission américaine — Géorgie",
      "status": "open",
      "city": "Tbilisi",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 65,
      "consularCapacityIndex": 80,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.79,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "de",
    "iso2": "DE",
    "name": "Allemagne",
    "capital": "Berlin",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 80.78,
    "economicIndex": 55,
    "militaryIndex": 49,
    "usTradeIndex": 72,
    "usAidIndex": 31,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE",
      "G7",
      "G20"
    ],
    "mission": {
      "id": "mission-de",
      "countryId": "de",
      "label": "Mission américaine — Allemagne",
      "status": "open",
      "city": "Berlin",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 67,
      "accessIndex": 62,
      "consularCapacityIndex": 77,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gh",
    "iso2": "GH",
    "name": "Ghana",
    "capital": "Accra",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 35
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 27.04,
    "economicIndex": 64,
    "militaryIndex": 58,
    "usTradeIndex": 63,
    "usAidIndex": 40,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 62,
      "economic": 57,
      "military": 55,
      "intelligence": 33,
      "trust": 47,
      "foreignPublicOpinion": 75,
      "dependency": 50,
      "tension": 23
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gh",
      "countryId": "gh",
      "label": "Mission américaine — Ghana",
      "status": "open",
      "city": "Accra",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 76,
      "accessIndex": 71,
      "consularCapacityIndex": 43,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gr",
    "iso2": "GR",
    "name": "Grèce",
    "capital": "Athens",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.99,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 33,
      "economic": 28,
      "military": 75,
      "intelligence": 53,
      "trust": 67,
      "foreignPublicOpinion": 46,
      "dependency": 70,
      "tension": 43
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-gr",
      "countryId": "gr",
      "label": "Mission américaine — Grèce",
      "status": "open",
      "city": "Athens",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gd",
    "iso2": "GD",
    "name": "Grenade",
    "capital": "St. George's",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.1,
    "economicIndex": 56,
    "militaryIndex": 50,
    "usTradeIndex": 55,
    "usAidIndex": 32,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gd",
      "countryId": "gd",
      "label": "Mission américaine — Grenade",
      "status": "open",
      "city": "St. George's",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 63,
      "consularCapacityIndex": 78,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gt",
    "iso2": "GT",
    "name": "Guatemala",
    "capital": "Guatemala City",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.81,
    "economicIndex": 38,
    "militaryIndex": 21,
    "usTradeIndex": 18,
    "usAidIndex": 1,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 37,
      "economic": 32,
      "military": 30,
      "intelligence": 57,
      "trust": 71,
      "foreignPublicOpinion": 50,
      "dependency": 74,
      "tension": 47
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gt",
      "countryId": "gt",
      "label": "Mission américaine — Guatemala",
      "status": "open",
      "city": "Guatemala City",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 43,
      "consularCapacityIndex": 67,
      "securityIndex": 41,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gn",
    "iso2": "GN",
    "name": "Guinée",
    "capital": "Conakry",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 9
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.63,
    "economicIndex": 76,
    "militaryIndex": 70,
    "usTradeIndex": 75,
    "usAidIndex": 52,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 74,
      "economic": 69,
      "military": 67,
      "intelligence": 45,
      "trust": 59,
      "foreignPublicOpinion": 38,
      "dependency": 62,
      "tension": 35
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gn",
      "countryId": "gn",
      "label": "Mission américaine — Guinée",
      "status": "open",
      "city": "Conakry",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 83,
      "consularCapacityIndex": 55,
      "securityIndex": 78,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.56,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gw",
    "iso2": "GW",
    "name": "Guinée-Bissau",
    "capital": "Bissau",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.75,
    "economicIndex": 44,
    "militaryIndex": 27,
    "usTradeIndex": 24,
    "usAidIndex": 7,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 43,
      "economic": 38,
      "military": 36,
      "intelligence": 63,
      "trust": 28,
      "foreignPublicOpinion": 56,
      "dependency": 31,
      "tension": 53
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gw",
      "countryId": "gw",
      "label": "Mission américaine — Guinée-Bissau",
      "status": "handling_post",
      "city": "Bissau",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 69,
      "accessIndex": 49,
      "consularCapacityIndex": 73,
      "securityIndex": 47,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.74,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gy",
    "iso2": "GY",
    "name": "Guyana",
    "capital": "Georgetown",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.78,
    "economicIndex": 48,
    "militaryIndex": 31,
    "usTradeIndex": 28,
    "usAidIndex": 11,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 47,
      "economic": 42,
      "military": 40,
      "intelligence": 67,
      "trust": 32,
      "foreignPublicOpinion": 60,
      "dependency": 35,
      "tension": 57
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-gy",
      "countryId": "gy",
      "label": "Mission américaine — Guyana",
      "status": "open",
      "city": "Georgetown",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 73,
      "accessIndex": 53,
      "consularCapacityIndex": 77,
      "securityIndex": 51,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ht",
    "iso2": "HT",
    "name": "Haïti",
    "capital": "Port-au-Prince",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Alix Didier Fils-Aimé",
      "title": "Premier ministre / chef du gouvernement de transition",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Primature d’Haïti — consulté 18/09/2026",
      "successionRiskIndex": 65
    },
    "regimeLabel": "République en transition institutionnelle",
    "populationMillions": 10.75,
    "economicIndex": 39,
    "militaryIndex": 22,
    "usTradeIndex": 19,
    "usAidIndex": 2,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 68,
      "economic": 52,
      "military": 34,
      "intelligence": 48,
      "trust": 55,
      "foreignPublicOpinion": 52,
      "dependency": 74,
      "tension": 48
    },
    "dependencies": [
      "textile",
      "diaspora/remises",
      "aide humanitaire"
    ],
    "disputes": [
      "Sécurité et gouvernance",
      "Assistance humanitaire",
      "Transition et élections",
      "Migration et protection consulaire"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ht",
      "countryId": "ht",
      "label": "Mission américaine — Haïti",
      "status": "open",
      "city": "Port-au-Prince",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 44,
      "consularCapacityIndex": 68,
      "securityIndex": 42,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.69,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "hn",
    "iso2": "HN",
    "name": "Honduras",
    "capital": "Tegucigalpa",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 10
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 8.73,
    "economicIndex": 77,
    "militaryIndex": 71,
    "usTradeIndex": 76,
    "usAidIndex": 53,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 3,
    "relation": {
      "diplomatic": 75,
      "economic": 70,
      "military": 68,
      "intelligence": 46,
      "trust": 60,
      "foreignPublicOpinion": 39,
      "dependency": 63,
      "tension": 36
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-hn",
      "countryId": "hn",
      "label": "Mission américaine — Honduras",
      "status": "open",
      "city": "Tegucigalpa",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 52,
      "accessIndex": 84,
      "consularCapacityIndex": 56,
      "securityIndex": 79,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.57,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "hu",
    "iso2": "HU",
    "name": "Hongrie",
    "capital": "Budapest",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.88,
    "economicIndex": 41,
    "militaryIndex": 24,
    "usTradeIndex": 21,
    "usAidIndex": 4,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 40,
      "economic": 35,
      "military": 33,
      "intelligence": 60,
      "trust": 74,
      "foreignPublicOpinion": 53,
      "dependency": 28,
      "tension": 50
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-hu",
      "countryId": "hu",
      "label": "Mission américaine — Hongrie",
      "status": "open",
      "city": "Budapest",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 66,
      "accessIndex": 46,
      "consularCapacityIndex": 70,
      "securityIndex": 44,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "is",
    "iso2": "IS",
    "name": "Islande",
    "capital": "Reykjavik",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.33,
    "economicIndex": 38,
    "militaryIndex": 21,
    "usTradeIndex": 18,
    "usAidIndex": 1,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 37,
      "economic": 32,
      "military": 30,
      "intelligence": 57,
      "trust": 71,
      "foreignPublicOpinion": 50,
      "dependency": 74,
      "tension": 47
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO"
    ],
    "mission": {
      "id": "mission-is",
      "countryId": "is",
      "label": "Mission américaine — Islande",
      "status": "open",
      "city": "Reykjavik",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 43,
      "consularCapacityIndex": 67,
      "securityIndex": 41,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "in",
    "iso2": "IN",
    "name": "Inde",
    "capital": "New Delhi",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 11
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1263.93,
    "economicIndex": 78,
    "militaryIndex": 72,
    "usTradeIndex": 77,
    "usAidIndex": 54,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 76,
      "economic": 71,
      "military": 69,
      "intelligence": 47,
      "trust": 61,
      "foreignPublicOpinion": 40,
      "dependency": 64,
      "tension": 37
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-in",
      "countryId": "in",
      "label": "Mission américaine — Inde",
      "status": "open",
      "city": "New Delhi",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 53,
      "accessIndex": 85,
      "consularCapacityIndex": 57,
      "securityIndex": 80,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.58,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "id",
    "iso2": "ID",
    "name": "Indonésie",
    "capital": "Jakarta",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 252.16,
    "economicIndex": 58,
    "militaryIndex": 52,
    "usTradeIndex": 57,
    "usAidIndex": 34,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 56,
      "economic": 51,
      "military": 49,
      "intelligence": 76,
      "trust": 41,
      "foreignPublicOpinion": 69,
      "dependency": 44,
      "tension": 62
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-id",
      "countryId": "id",
      "label": "Mission américaine — Indonésie",
      "status": "open",
      "city": "Jakarta",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 65,
      "consularCapacityIndex": 80,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.79,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ir",
    "iso2": "IR",
    "name": "Iran",
    "capital": "Tehran",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 19
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 77.97,
    "economicIndex": 36,
    "militaryIndex": 80,
    "usTradeIndex": 16,
    "usAidIndex": 62,
    "sanctionsLevel": 94,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 16,
      "economic": 10,
      "military": 8,
      "intelligence": 8,
      "trust": 8,
      "foreignPublicOpinion": 20,
      "dependency": 18,
      "tension": 90
    },
    "dependencies": [],
    "disputes": [
      "Programme nucléaire et sanctions",
      "Sécurité régionale",
      "Détentions / crises consulaires"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ir",
      "countryId": "ir",
      "label": "Mission américaine — Iran",
      "status": "no_relations",
      "city": "Tehran",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 61,
      "accessIndex": 41,
      "consularCapacityIndex": 65,
      "securityIndex": 88,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.66,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "iq",
    "iso2": "IQ",
    "name": "Irak",
    "capital": "Baghdad",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 36.0,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 33,
      "economic": 28,
      "military": 75,
      "intelligence": 53,
      "trust": 67,
      "foreignPublicOpinion": 46,
      "dependency": 70,
      "tension": 43
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-iq",
      "countryId": "iq",
      "label": "Mission américaine — Irak",
      "status": "open",
      "city": "Baghdad",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ie",
    "iso2": "IE",
    "name": "Irlande",
    "capital": "Dublin",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.38,
    "economicIndex": 60,
    "militaryIndex": 54,
    "usTradeIndex": 59,
    "usAidIndex": 36,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 58,
      "economic": 53,
      "military": 51,
      "intelligence": 29,
      "trust": 43,
      "foreignPublicOpinion": 71,
      "dependency": 46,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "UE"
    ],
    "mission": {
      "id": "mission-ie",
      "countryId": "ie",
      "label": "Mission américaine — Irlande",
      "status": "open",
      "city": "Dublin",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 67,
      "consularCapacityIndex": 82,
      "securityIndex": 62,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "il",
    "iso2": "IL",
    "name": "Israël",
    "capital": "Jerusalem",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Benjamin Netanyahu",
      "title": "Premier ministre",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Knesset — 37e gouvernement, consulté 18/09/2026",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Démocratie parlementaire",
    "populationMillions": 8.27,
    "economicIndex": 74,
    "militaryIndex": 68,
    "usTradeIndex": 73,
    "usAidIndex": 50,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 82,
      "economic": 73,
      "military": 91,
      "intelligence": 84,
      "trust": 75,
      "foreignPublicOpinion": 62,
      "dependency": 58,
      "tension": 34
    },
    "dependencies": [
      "défense",
      "cyber",
      "technologie"
    ],
    "disputes": [
      "Sécurité régionale",
      "Gaza / diplomatie humanitaire",
      "Iran et menaces régionales",
      "Processus politique israélo-palestinien"
    ],
    "allianceTags": [
      "Partenaire de sécurité majeur"
    ],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-il",
      "countryId": "il",
      "label": "Mission américaine — Israël",
      "status": "open",
      "city": "Jerusalem",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 49,
      "accessIndex": 81,
      "consularCapacityIndex": 53,
      "securityIndex": 76,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.54,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "it",
    "iso2": "IT",
    "name": "Italie",
    "capital": "Rome",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 60.77,
    "economicIndex": 40,
    "militaryIndex": 23,
    "usTradeIndex": 20,
    "usAidIndex": 3,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 39,
      "economic": 34,
      "military": 32,
      "intelligence": 59,
      "trust": 73,
      "foreignPublicOpinion": 52,
      "dependency": 76,
      "tension": 49
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE",
      "G7",
      "G20"
    ],
    "mission": {
      "id": "mission-it",
      "countryId": "it",
      "label": "Mission américaine — Italie",
      "status": "open",
      "city": "Rome",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 65,
      "accessIndex": 45,
      "consularCapacityIndex": 69,
      "securityIndex": 43,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.7,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "jm",
    "iso2": "JM",
    "name": "Jamaïque",
    "capital": "Kingston",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 10
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.72,
    "economicIndex": 77,
    "militaryIndex": 71,
    "usTradeIndex": 76,
    "usAidIndex": 53,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 3,
    "relation": {
      "diplomatic": 75,
      "economic": 70,
      "military": 68,
      "intelligence": 46,
      "trust": 60,
      "foreignPublicOpinion": 39,
      "dependency": 63,
      "tension": 36
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-jm",
      "countryId": "jm",
      "label": "Mission américaine — Jamaïque",
      "status": "open",
      "city": "Kingston",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 52,
      "accessIndex": 84,
      "consularCapacityIndex": 56,
      "securityIndex": 79,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.57,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "jp",
    "iso2": "JP",
    "name": "Japon",
    "capital": "Tokyo",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 16
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 127.08,
    "economicIndex": 83,
    "militaryIndex": 77,
    "usTradeIndex": 72,
    "usAidIndex": 59,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 90,
      "economic": 88,
      "military": 88,
      "intelligence": 82,
      "trust": 84,
      "foreignPublicOpinion": 68,
      "dependency": 64,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Alliance / traité de sécurité US"
    ],
    "memberships": [
      "ONU",
      "G7",
      "G20"
    ],
    "mission": {
      "id": "mission-jp",
      "countryId": "jp",
      "label": "Mission américaine — Japon",
      "status": "open",
      "city": "Tokyo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 58,
      "accessIndex": 38,
      "consularCapacityIndex": 62,
      "securityIndex": 85,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.63,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "jo",
    "iso2": "JO",
    "name": "Jordanie",
    "capital": "Amman",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 14
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.67,
    "economicIndex": 81,
    "militaryIndex": 75,
    "usTradeIndex": 80,
    "usAidIndex": 57,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 30,
      "economic": 74,
      "military": 72,
      "intelligence": 50,
      "trust": 64,
      "foreignPublicOpinion": 43,
      "dependency": 67,
      "tension": 40
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-jo",
      "countryId": "jo",
      "label": "Mission américaine — Jordanie",
      "status": "open",
      "city": "Amman",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 56,
      "accessIndex": 36,
      "consularCapacityIndex": 60,
      "securityIndex": 83,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.61,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kz",
    "iso2": "KZ",
    "name": "Kazakhstan",
    "capital": "Astana",
    "region": "Asia",
    "subregion": "Central Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 17.38,
    "economicIndex": 54,
    "militaryIndex": 37,
    "usTradeIndex": 34,
    "usAidIndex": 17,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kz",
      "countryId": "kz",
      "label": "Mission américaine — Kazakhstan",
      "status": "open",
      "city": "Astana",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 59,
      "consularCapacityIndex": 83,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.84,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ke",
    "iso2": "KE",
    "name": "Kenya",
    "capital": "Nairobi",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 41.8,
    "economicIndex": 62,
    "militaryIndex": 56,
    "usTradeIndex": 61,
    "usAidIndex": 38,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 60,
      "economic": 55,
      "military": 53,
      "intelligence": 31,
      "trust": 45,
      "foreignPublicOpinion": 73,
      "dependency": 48,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ke",
      "countryId": "ke",
      "label": "Mission américaine — Kenya",
      "status": "open",
      "city": "Nairobi",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 74,
      "accessIndex": 69,
      "consularCapacityIndex": 84,
      "securityIndex": 64,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ki",
    "iso2": "KI",
    "name": "Kiribati",
    "capital": "South Tarawa",
    "region": "Oceania",
    "subregion": "Micronesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 41
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.11,
    "economicIndex": 70,
    "militaryIndex": 64,
    "usTradeIndex": 69,
    "usAidIndex": 46,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 25,
    "relation": {
      "diplomatic": 68,
      "economic": 63,
      "military": 61,
      "intelligence": 39,
      "trust": 53,
      "foreignPublicOpinion": 32,
      "dependency": 56,
      "tension": 29
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ki",
      "countryId": "ki",
      "label": "Mission américaine — Kiribati",
      "status": "handling_post",
      "city": "South Tarawa",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 82,
      "accessIndex": 77,
      "consularCapacityIndex": 49,
      "securityIndex": 72,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.5,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kw",
    "iso2": "KW",
    "name": "Koweït",
    "capital": "Kuwait City",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.27,
    "economicIndex": 48,
    "militaryIndex": 31,
    "usTradeIndex": 28,
    "usAidIndex": 11,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 47,
      "economic": 42,
      "military": 40,
      "intelligence": 67,
      "trust": 32,
      "foreignPublicOpinion": 60,
      "dependency": 35,
      "tension": 57
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kw",
      "countryId": "kw",
      "label": "Mission américaine — Koweït",
      "status": "open",
      "city": "Kuwait City",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 73,
      "accessIndex": 53,
      "consularCapacityIndex": 77,
      "securityIndex": 51,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kg",
    "iso2": "KG",
    "name": "Kirghizstan",
    "capital": "Bishkek",
    "region": "Asia",
    "subregion": "Central Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.78,
    "economicIndex": 66,
    "militaryIndex": 60,
    "usTradeIndex": 65,
    "usAidIndex": 42,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 64,
      "economic": 59,
      "military": 57,
      "intelligence": 35,
      "trust": 49,
      "foreignPublicOpinion": 28,
      "dependency": 52,
      "tension": 25
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kg",
      "countryId": "kg",
      "label": "Mission américaine — Kirghizstan",
      "status": "open",
      "city": "Bishkek",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 78,
      "accessIndex": 73,
      "consularCapacityIndex": 45,
      "securityIndex": 68,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "la",
    "iso2": "LA",
    "name": "Laos",
    "capital": "Vientiane",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.69,
    "economicIndex": 55,
    "militaryIndex": 49,
    "usTradeIndex": 54,
    "usAidIndex": 31,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-la",
      "countryId": "la",
      "label": "Mission américaine — Laos",
      "status": "open",
      "city": "Vientiane",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 67,
      "accessIndex": 62,
      "consularCapacityIndex": 77,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lv",
    "iso2": "LV",
    "name": "Lettonie",
    "capital": "Riga",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.99,
    "economicIndex": 47,
    "militaryIndex": 30,
    "usTradeIndex": 27,
    "usAidIndex": 10,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 46,
      "economic": 41,
      "military": 39,
      "intelligence": 66,
      "trust": 31,
      "foreignPublicOpinion": 59,
      "dependency": 34,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-lv",
      "countryId": "lv",
      "label": "Mission américaine — Lettonie",
      "status": "open",
      "city": "Riga",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 52,
      "consularCapacityIndex": 76,
      "securityIndex": 50,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lb",
    "iso2": "LB",
    "name": "Liban",
    "capital": "Beirut",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.1,
    "economicIndex": 57,
    "militaryIndex": 51,
    "usTradeIndex": 56,
    "usAidIndex": 33,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 55,
      "economic": 50,
      "military": 48,
      "intelligence": 75,
      "trust": 40,
      "foreignPublicOpinion": 68,
      "dependency": 43,
      "tension": 61
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-lb",
      "countryId": "lb",
      "label": "Mission américaine — Liban",
      "status": "open",
      "city": "Beirut",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 64,
      "consularCapacityIndex": 79,
      "securityIndex": 59,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ls",
    "iso2": "LS",
    "name": "Lesotho",
    "capital": "Maseru",
    "region": "Africa",
    "subregion": "Southern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.1,
    "economicIndex": 41,
    "militaryIndex": 24,
    "usTradeIndex": 21,
    "usAidIndex": 4,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 40,
      "economic": 35,
      "military": 33,
      "intelligence": 60,
      "trust": 74,
      "foreignPublicOpinion": 53,
      "dependency": 28,
      "tension": 50
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ls",
      "countryId": "ls",
      "label": "Mission américaine — Lesotho",
      "status": "open",
      "city": "Maseru",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 66,
      "accessIndex": 46,
      "consularCapacityIndex": 70,
      "securityIndex": 44,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lr",
    "iso2": "LR",
    "name": "Liberia",
    "capital": "Monrovia",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 22
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.4,
    "economicIndex": 39,
    "militaryIndex": 22,
    "usTradeIndex": 19,
    "usAidIndex": 2,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 38,
      "economic": 33,
      "military": 31,
      "intelligence": 58,
      "trust": 72,
      "foreignPublicOpinion": 51,
      "dependency": 75,
      "tension": 48
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-lr",
      "countryId": "lr",
      "label": "Mission américaine — Liberia",
      "status": "open",
      "city": "Monrovia",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 44,
      "consularCapacityIndex": 68,
      "securityIndex": 42,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.69,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ly",
    "iso2": "LY",
    "name": "Libye",
    "capital": "Tripoli",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.25,
    "economicIndex": 53,
    "militaryIndex": 36,
    "usTradeIndex": 33,
    "usAidIndex": 16,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 52,
      "economic": 47,
      "military": 45,
      "intelligence": 72,
      "trust": 37,
      "foreignPublicOpinion": 65,
      "dependency": 40,
      "tension": 62
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ly",
      "countryId": "ly",
      "label": "Mission américaine — Libye",
      "status": "open",
      "city": "Tripoli",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 78,
      "accessIndex": 58,
      "consularCapacityIndex": 82,
      "securityIndex": 56,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "li",
    "iso2": "LI",
    "name": "Liechtenstein",
    "capital": "Vaduz",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 42
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.04,
    "economicIndex": 71,
    "militaryIndex": 65,
    "usTradeIndex": 70,
    "usAidIndex": 47,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 69,
      "economic": 64,
      "military": 62,
      "intelligence": 40,
      "trust": 54,
      "foreignPublicOpinion": 33,
      "dependency": 57,
      "tension": 30
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-li",
      "countryId": "li",
      "label": "Mission américaine — Liechtenstein",
      "status": "handling_post",
      "city": "Vaduz",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 83,
      "accessIndex": 78,
      "consularCapacityIndex": 50,
      "securityIndex": 73,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lt",
    "iso2": "LT",
    "name": "Lituanie",
    "capital": "Vilnius",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.93,
    "economicIndex": 43,
    "militaryIndex": 26,
    "usTradeIndex": 23,
    "usAidIndex": 6,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 42,
      "economic": 37,
      "military": 35,
      "intelligence": 62,
      "trust": 76,
      "foreignPublicOpinion": 55,
      "dependency": 30,
      "tension": 52
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-lt",
      "countryId": "lt",
      "label": "Mission américaine — Lituanie",
      "status": "open",
      "city": "Vilnius",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 48,
      "consularCapacityIndex": 72,
      "securityIndex": 46,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lu",
    "iso2": "LU",
    "name": "Luxembourg",
    "capital": "Luxembourg",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.55,
    "economicIndex": 45,
    "militaryIndex": 28,
    "usTradeIndex": 25,
    "usAidIndex": 8,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 44,
      "economic": 39,
      "military": 37,
      "intelligence": 64,
      "trust": 29,
      "foreignPublicOpinion": 57,
      "dependency": 32,
      "tension": 54
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-lu",
      "countryId": "lu",
      "label": "Mission américaine — Luxembourg",
      "status": "open",
      "city": "Luxembourg",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 50,
      "consularCapacityIndex": 74,
      "securityIndex": 48,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.75,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mg",
    "iso2": "MG",
    "name": "Madagascar",
    "capital": "Antananarivo",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 21.84,
    "economicIndex": 68,
    "militaryIndex": 62,
    "usTradeIndex": 67,
    "usAidIndex": 44,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 66,
      "economic": 61,
      "military": 59,
      "intelligence": 37,
      "trust": 51,
      "foreignPublicOpinion": 30,
      "dependency": 54,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mg",
      "countryId": "mg",
      "label": "Mission américaine — Madagascar",
      "status": "open",
      "city": "Antananarivo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 75,
      "consularCapacityIndex": 47,
      "securityIndex": 70,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.48,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mw",
    "iso2": "MW",
    "name": "Malawi",
    "capital": "Lilongwe",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.81,
    "economicIndex": 50,
    "militaryIndex": 33,
    "usTradeIndex": 30,
    "usAidIndex": 13,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 49,
      "economic": 44,
      "military": 42,
      "intelligence": 69,
      "trust": 34,
      "foreignPublicOpinion": 62,
      "dependency": 37,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mw",
      "countryId": "mw",
      "label": "Mission américaine — Malawi",
      "status": "open",
      "city": "Lilongwe",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 75,
      "accessIndex": 55,
      "consularCapacityIndex": 79,
      "securityIndex": 53,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "my",
    "iso2": "MY",
    "name": "Malaisie",
    "capital": "Kuala Lumpur",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 30.43,
    "economicIndex": 54,
    "militaryIndex": 37,
    "usTradeIndex": 34,
    "usAidIndex": 17,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 53,
      "economic": 48,
      "military": 46,
      "intelligence": 73,
      "trust": 38,
      "foreignPublicOpinion": 66,
      "dependency": 41,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-my",
      "countryId": "my",
      "label": "Mission américaine — Malaisie",
      "status": "open",
      "city": "Kuala Lumpur",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 59,
      "consularCapacityIndex": 83,
      "securityIndex": 57,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.84,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mv",
    "iso2": "MV",
    "name": "Maldives",
    "capital": "Malé",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.34,
    "economicIndex": 48,
    "militaryIndex": 31,
    "usTradeIndex": 28,
    "usAidIndex": 11,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 47,
      "economic": 42,
      "military": 40,
      "intelligence": 67,
      "trust": 32,
      "foreignPublicOpinion": 60,
      "dependency": 35,
      "tension": 57
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mv",
      "countryId": "mv",
      "label": "Mission américaine — Maldives",
      "status": "handling_post",
      "city": "Malé",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 73,
      "accessIndex": 53,
      "consularCapacityIndex": 77,
      "securityIndex": 51,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ml",
    "iso2": "ML",
    "name": "Mali",
    "capital": "Bamako",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 11
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.77,
    "economicIndex": 78,
    "militaryIndex": 72,
    "usTradeIndex": 77,
    "usAidIndex": 54,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 76,
      "economic": 71,
      "military": 69,
      "intelligence": 47,
      "trust": 61,
      "foreignPublicOpinion": 40,
      "dependency": 64,
      "tension": 37
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ml",
      "countryId": "ml",
      "label": "Mission américaine — Mali",
      "status": "open",
      "city": "Bamako",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 53,
      "accessIndex": 85,
      "consularCapacityIndex": 57,
      "securityIndex": 80,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.58,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mt",
    "iso2": "MT",
    "name": "Malte",
    "capital": "Valletta",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.42,
    "economicIndex": 44,
    "militaryIndex": 27,
    "usTradeIndex": 24,
    "usAidIndex": 7,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 43,
      "economic": 38,
      "military": 36,
      "intelligence": 63,
      "trust": 28,
      "foreignPublicOpinion": 56,
      "dependency": 31,
      "tension": 53
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "UE"
    ],
    "mission": {
      "id": "mission-mt",
      "countryId": "mt",
      "label": "Mission américaine — Malte",
      "status": "open",
      "city": "Valletta",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 49,
      "consularCapacityIndex": 73,
      "securityIndex": 47,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.74,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mh",
    "iso2": "MH",
    "name": "Îles Marshall",
    "capital": "Majuro",
    "region": "Oceania",
    "subregion": "Micronesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 41
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.06,
    "economicIndex": 70,
    "militaryIndex": 64,
    "usTradeIndex": 69,
    "usAidIndex": 46,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 25,
    "relation": {
      "diplomatic": 68,
      "economic": 63,
      "military": 61,
      "intelligence": 39,
      "trust": 53,
      "foreignPublicOpinion": 32,
      "dependency": 56,
      "tension": 29
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mh",
      "countryId": "mh",
      "label": "Mission américaine — Îles Marshall",
      "status": "open",
      "city": "Majuro",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 82,
      "accessIndex": 77,
      "consularCapacityIndex": 49,
      "securityIndex": 72,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.5,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mr",
    "iso2": "MR",
    "name": "Mauritanie",
    "capital": "Nouakchott",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.55,
    "economicIndex": 40,
    "militaryIndex": 23,
    "usTradeIndex": 20,
    "usAidIndex": 3,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 16,
    "relation": {
      "diplomatic": 39,
      "economic": 34,
      "military": 32,
      "intelligence": 59,
      "trust": 73,
      "foreignPublicOpinion": 52,
      "dependency": 76,
      "tension": 49
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mr",
      "countryId": "mr",
      "label": "Mission américaine — Mauritanie",
      "status": "open",
      "city": "Nouakchott",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 65,
      "accessIndex": 45,
      "consularCapacityIndex": 69,
      "securityIndex": 43,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.7,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mu",
    "iso2": "MU",
    "name": "Maurice",
    "capital": "Port Louis",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.26,
    "economicIndex": 46,
    "militaryIndex": 29,
    "usTradeIndex": 26,
    "usAidIndex": 9,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 45,
      "economic": 40,
      "military": 38,
      "intelligence": 65,
      "trust": 30,
      "foreignPublicOpinion": 58,
      "dependency": 33,
      "tension": 55
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mu",
      "countryId": "mu",
      "label": "Mission américaine — Maurice",
      "status": "open",
      "city": "Port Louis",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 71,
      "accessIndex": 51,
      "consularCapacityIndex": 75,
      "securityIndex": 49,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mx",
    "iso2": "MX",
    "name": "Mexique",
    "capital": "Mexico City",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Claudia Sheinbaum Pardo",
      "title": "Présidente des États-Unis mexicains",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Présidence du Mexique — 15/09/2026",
      "successionRiskIndex": 12
    },
    "regimeLabel": "République fédérale présidentielle",
    "populationMillions": 119.71,
    "economicIndex": 52,
    "militaryIndex": 35,
    "usTradeIndex": 72,
    "usAidIndex": 15,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 74,
      "economic": 92,
      "military": 58,
      "intelligence": 62,
      "trust": 64,
      "foreignPublicOpinion": 58,
      "dependency": 88,
      "tension": 42
    },
    "dependencies": [
      "automobile",
      "électronique",
      "agriculture",
      "logistique nord-américaine"
    ],
    "disputes": [
      "Frontière et migration",
      "Fentanyl/crime transnational",
      "USMCA et commerce",
      "Eau, énergie et coopération frontalière"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-mx",
      "countryId": "mx",
      "label": "Mission américaine — Mexique",
      "status": "open",
      "city": "Mexico City",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 57,
      "consularCapacityIndex": 81,
      "securityIndex": 55,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.82,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "fm",
    "iso2": "FM",
    "name": "Micronésie",
    "capital": "Palikir",
    "region": "Oceania",
    "subregion": "Micronesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 44
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.1,
    "economicIndex": 73,
    "militaryIndex": 67,
    "usTradeIndex": 72,
    "usAidIndex": 49,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 71,
      "economic": 66,
      "military": 64,
      "intelligence": 42,
      "trust": 56,
      "foreignPublicOpinion": 35,
      "dependency": 59,
      "tension": 32
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-fm",
      "countryId": "fm",
      "label": "Mission américaine — Micronésie",
      "status": "open",
      "city": "Palikir",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 80,
      "consularCapacityIndex": 52,
      "securityIndex": 75,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "md",
    "iso2": "MD",
    "name": "Moldavie",
    "capital": "Chișinău",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.56,
    "economicIndex": 62,
    "militaryIndex": 56,
    "usTradeIndex": 61,
    "usAidIndex": 38,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 60,
      "economic": 55,
      "military": 53,
      "intelligence": 31,
      "trust": 45,
      "foreignPublicOpinion": 73,
      "dependency": 48,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-md",
      "countryId": "md",
      "label": "Mission américaine — Moldavie",
      "status": "open",
      "city": "Chișinău",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 74,
      "accessIndex": 69,
      "consularCapacityIndex": 84,
      "securityIndex": 64,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mc",
    "iso2": "MC",
    "name": "Monaco",
    "capital": "Monaco",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.04,
    "economicIndex": 60,
    "militaryIndex": 54,
    "usTradeIndex": 59,
    "usAidIndex": 36,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 58,
      "economic": 53,
      "military": 51,
      "intelligence": 29,
      "trust": 43,
      "foreignPublicOpinion": 71,
      "dependency": 46,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mc",
      "countryId": "mc",
      "label": "Mission américaine — Monaco",
      "status": "handling_post",
      "city": "Monaco",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 72,
      "accessIndex": 67,
      "consularCapacityIndex": 82,
      "securityIndex": 62,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mn",
    "iso2": "MN",
    "name": "Mongolie",
    "capital": "Ulan Bator",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.99,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mn",
      "countryId": "mn",
      "label": "Mission américaine — Mongolie",
      "status": "open",
      "city": "Ulan Bator",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "me",
    "iso2": "ME",
    "name": "Monténégro",
    "capital": "Non renseignée",
    "region": "Autre",
    "subregion": "Non renseignée",
    "stateBureau": "SPECIAL",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 35
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 64,
    "militaryIndex": 58,
    "usTradeIndex": 63,
    "usAidIndex": 40,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 62,
      "economic": 57,
      "military": 55,
      "intelligence": 33,
      "trust": 47,
      "foreignPublicOpinion": 75,
      "dependency": 50,
      "tension": 23
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO"
    ],
    "mission": {
      "id": "mission-me",
      "countryId": "me",
      "label": "Mission américaine — Monténégro",
      "status": "open",
      "city": "Non renseignée",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 76,
      "accessIndex": 71,
      "consularCapacityIndex": 43,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ma",
    "iso2": "MA",
    "name": "Maroc",
    "capital": "Rabat",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 27
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 33.47,
    "economicIndex": 56,
    "militaryIndex": 50,
    "usTradeIndex": 55,
    "usAidIndex": 32,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ma",
      "countryId": "ma",
      "label": "Mission américaine — Maroc",
      "status": "open",
      "city": "Rabat",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 63,
      "consularCapacityIndex": 78,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mz",
    "iso2": "MZ",
    "name": "Mozambique",
    "capital": "Maputo",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 25.04,
    "economicIndex": 56,
    "militaryIndex": 39,
    "usTradeIndex": 36,
    "usAidIndex": 19,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 3,
    "relation": {
      "diplomatic": 55,
      "economic": 50,
      "military": 48,
      "intelligence": 75,
      "trust": 40,
      "foreignPublicOpinion": 68,
      "dependency": 43,
      "tension": 20
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mz",
      "countryId": "mz",
      "label": "Mission américaine — Mozambique",
      "status": "open",
      "city": "Maputo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 81,
      "accessIndex": 61,
      "consularCapacityIndex": 42,
      "securityIndex": 59,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.86,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mm",
    "iso2": "MM",
    "name": "Myanmar (Birmanie)",
    "capital": "Non renseignée",
    "region": "Autre",
    "subregion": "Non renseignée",
    "stateBureau": "SPECIAL",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 13
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 80,
    "militaryIndex": 74,
    "usTradeIndex": 79,
    "usAidIndex": 56,
    "sanctionsLevel": 18,
    "usBaseAccessIndex": 6,
    "relation": {
      "diplomatic": 29,
      "economic": 73,
      "military": 71,
      "intelligence": 49,
      "trust": 63,
      "foreignPublicOpinion": 42,
      "dependency": 66,
      "tension": 39
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-mm",
      "countryId": "mm",
      "label": "Mission américaine — Myanmar (Birmanie)",
      "status": "open",
      "city": "Non renseignée",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 55,
      "accessIndex": 35,
      "consularCapacityIndex": 59,
      "securityIndex": 82,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.6,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "na",
    "iso2": "NA",
    "name": "Namibie",
    "capital": "Windhoek",
    "region": "Africa",
    "subregion": "Southern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.11,
    "economicIndex": 57,
    "militaryIndex": 51,
    "usTradeIndex": 56,
    "usAidIndex": 33,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 55,
      "economic": 50,
      "military": 48,
      "intelligence": 75,
      "trust": 40,
      "foreignPublicOpinion": 68,
      "dependency": 43,
      "tension": 61
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-na",
      "countryId": "na",
      "label": "Mission américaine — Namibie",
      "status": "open",
      "city": "Windhoek",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 69,
      "accessIndex": 64,
      "consularCapacityIndex": 79,
      "securityIndex": 59,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "nr",
    "iso2": "NR",
    "name": "Nauru",
    "capital": "Yaren",
    "region": "Oceania",
    "subregion": "Micronesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.01,
    "economicIndex": 41,
    "militaryIndex": 24,
    "usTradeIndex": 21,
    "usAidIndex": 4,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 40,
      "economic": 35,
      "military": 33,
      "intelligence": 60,
      "trust": 74,
      "foreignPublicOpinion": 53,
      "dependency": 28,
      "tension": 50
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-nr",
      "countryId": "nr",
      "label": "Mission américaine — Nauru",
      "status": "handling_post",
      "city": "Yaren",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 66,
      "accessIndex": 46,
      "consularCapacityIndex": 70,
      "securityIndex": 44,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "np",
    "iso2": "NP",
    "name": "Népal",
    "capital": "Kathmandu",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 20
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 27.65,
    "economicIndex": 37,
    "militaryIndex": 20,
    "usTradeIndex": 17,
    "usAidIndex": 0,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 36,
      "economic": 31,
      "military": 29,
      "intelligence": 56,
      "trust": 70,
      "foreignPublicOpinion": 49,
      "dependency": 73,
      "tension": 46
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-np",
      "countryId": "np",
      "label": "Mission américaine — Népal",
      "status": "open",
      "city": "Kathmandu",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 62,
      "accessIndex": 42,
      "consularCapacityIndex": 66,
      "securityIndex": 40,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.67,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "nl",
    "iso2": "NL",
    "name": "Pays-Bas",
    "capital": "Amsterdam",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 12
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 16.88,
    "economicIndex": 79,
    "militaryIndex": 73,
    "usTradeIndex": 78,
    "usAidIndex": 55,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 5,
    "relation": {
      "diplomatic": 28,
      "economic": 72,
      "military": 70,
      "intelligence": 48,
      "trust": 62,
      "foreignPublicOpinion": 41,
      "dependency": 65,
      "tension": 38
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-nl",
      "countryId": "nl",
      "label": "Mission américaine — Pays-Bas",
      "status": "open",
      "city": "Amsterdam",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 54,
      "accessIndex": 86,
      "consularCapacityIndex": 58,
      "securityIndex": 81,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.59,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "nz",
    "iso2": "NZ",
    "name": "Nouvelle-Zélande",
    "capital": "Wellington",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.55,
    "economicIndex": 57,
    "militaryIndex": 40,
    "usTradeIndex": 37,
    "usAidIndex": 20,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 56,
      "economic": 51,
      "military": 49,
      "intelligence": 76,
      "trust": 41,
      "foreignPublicOpinion": 69,
      "dependency": 44,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-nz",
      "countryId": "nz",
      "label": "Mission américaine — Nouvelle-Zélande",
      "status": "open",
      "city": "Wellington",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 82,
      "accessIndex": 62,
      "consularCapacityIndex": 43,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ni",
    "iso2": "NI",
    "name": "Nicaragua",
    "capital": "Managua",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 44
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.13,
    "economicIndex": 73,
    "militaryIndex": 67,
    "usTradeIndex": 72,
    "usAidIndex": 49,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 71,
      "economic": 66,
      "military": 64,
      "intelligence": 42,
      "trust": 56,
      "foreignPublicOpinion": 35,
      "dependency": 59,
      "tension": 32
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ni",
      "countryId": "ni",
      "label": "Mission américaine — Nicaragua",
      "status": "open",
      "city": "Managua",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 80,
      "consularCapacityIndex": 52,
      "securityIndex": 75,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ne",
    "iso2": "NE",
    "name": "Niger",
    "capital": "Niamey",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 17.14,
    "economicIndex": 65,
    "militaryIndex": 59,
    "usTradeIndex": 64,
    "usAidIndex": 41,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 63,
      "economic": 58,
      "military": 56,
      "intelligence": 34,
      "trust": 48,
      "foreignPublicOpinion": 76,
      "dependency": 51,
      "tension": 24
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ne",
      "countryId": "ne",
      "label": "Mission américaine — Niger",
      "status": "open",
      "city": "Niamey",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 72,
      "consularCapacityIndex": 44,
      "securityIndex": 67,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.86,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ng",
    "iso2": "NG",
    "name": "Nigeria",
    "capital": "Abuja",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 178.52,
    "economicIndex": 69,
    "militaryIndex": 63,
    "usTradeIndex": 68,
    "usAidIndex": 45,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 67,
      "economic": 62,
      "military": 60,
      "intelligence": 38,
      "trust": 52,
      "foreignPublicOpinion": 31,
      "dependency": 55,
      "tension": 28
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ng",
      "countryId": "ng",
      "label": "Mission américaine — Nigeria",
      "status": "open",
      "city": "Abuja",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 81,
      "accessIndex": 76,
      "consularCapacityIndex": 48,
      "securityIndex": 71,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.49,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "mk",
    "iso2": "MK",
    "name": "Macédoine du Nord",
    "capital": "Skopje",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 9
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.06,
    "economicIndex": 76,
    "militaryIndex": 70,
    "usTradeIndex": 75,
    "usAidIndex": 52,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 74,
      "economic": 69,
      "military": 67,
      "intelligence": 45,
      "trust": 59,
      "foreignPublicOpinion": 38,
      "dependency": 62,
      "tension": 35
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO"
    ],
    "mission": {
      "id": "mission-mk",
      "countryId": "mk",
      "label": "Mission américaine — Macédoine du Nord",
      "status": "open",
      "city": "Skopje",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 83,
      "consularCapacityIndex": 55,
      "securityIndex": 78,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.56,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "no",
    "iso2": "NO",
    "name": "Norvège",
    "capital": "Oslo",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 18
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.16,
    "economicIndex": 35,
    "militaryIndex": 79,
    "usTradeIndex": 15,
    "usAidIndex": 61,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 34,
      "economic": 29,
      "military": 76,
      "intelligence": 54,
      "trust": 68,
      "foreignPublicOpinion": 47,
      "dependency": 71,
      "tension": 44
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO"
    ],
    "mission": {
      "id": "mission-no",
      "countryId": "no",
      "label": "Mission américaine — Norvège",
      "status": "open",
      "city": "Oslo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 60,
      "accessIndex": 40,
      "consularCapacityIndex": 64,
      "securityIndex": 87,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.65,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "om",
    "iso2": "OM",
    "name": "Oman",
    "capital": "Muscat",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 4.09,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-om",
      "countryId": "om",
      "label": "Mission américaine — Oman",
      "status": "open",
      "city": "Muscat",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pk",
    "iso2": "PK",
    "name": "Pakistan",
    "capital": "Islamabad",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 12
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 188.41,
    "economicIndex": 79,
    "militaryIndex": 73,
    "usTradeIndex": 78,
    "usAidIndex": 55,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 5,
    "relation": {
      "diplomatic": 28,
      "economic": 72,
      "military": 70,
      "intelligence": 48,
      "trust": 62,
      "foreignPublicOpinion": 41,
      "dependency": 65,
      "tension": 38
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-pk",
      "countryId": "pk",
      "label": "Mission américaine — Pakistan",
      "status": "open",
      "city": "Islamabad",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 54,
      "accessIndex": 86,
      "consularCapacityIndex": 58,
      "securityIndex": 81,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.59,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pw",
    "iso2": "PW",
    "name": "Palaos",
    "capital": "Ngerulmud",
    "region": "Oceania",
    "subregion": "Micronesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.02,
    "economicIndex": 53,
    "militaryIndex": 36,
    "usTradeIndex": 33,
    "usAidIndex": 16,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 52,
      "economic": 47,
      "military": 45,
      "intelligence": 72,
      "trust": 37,
      "foreignPublicOpinion": 65,
      "dependency": 40,
      "tension": 62
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-pw",
      "countryId": "pw",
      "label": "Mission américaine — Palaos",
      "status": "open",
      "city": "Ngerulmud",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 78,
      "accessIndex": 58,
      "consularCapacityIndex": 82,
      "securityIndex": 56,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pa",
    "iso2": "PA",
    "name": "Panama",
    "capital": "Panama City",
    "region": "Americas",
    "subregion": "Central America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.71,
    "economicIndex": 59,
    "militaryIndex": 53,
    "usTradeIndex": 58,
    "usAidIndex": 35,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 57,
      "economic": 52,
      "military": 50,
      "intelligence": 28,
      "trust": 42,
      "foreignPublicOpinion": 70,
      "dependency": 45,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-pa",
      "countryId": "pa",
      "label": "Mission américaine — Panama",
      "status": "open",
      "city": "Panama City",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 71,
      "accessIndex": 66,
      "consularCapacityIndex": 81,
      "securityIndex": 61,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pg",
    "iso2": "PG",
    "name": "Papouasie-Nouvelle-Guinée",
    "capital": "Port Moresby",
    "region": "Oceania",
    "subregion": "Melanesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 42
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 7.4,
    "economicIndex": 71,
    "militaryIndex": 65,
    "usTradeIndex": 70,
    "usAidIndex": 47,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 69,
      "economic": 64,
      "military": 62,
      "intelligence": 40,
      "trust": 54,
      "foreignPublicOpinion": 33,
      "dependency": 57,
      "tension": 30
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-pg",
      "countryId": "pg",
      "label": "Mission américaine — Papouasie-Nouvelle-Guinée",
      "status": "open",
      "city": "Port Moresby",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 83,
      "accessIndex": 78,
      "consularCapacityIndex": 50,
      "securityIndex": 73,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "py",
    "iso2": "PY",
    "name": "Paraguay",
    "capital": "Asunción",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.89,
    "economicIndex": 57,
    "militaryIndex": 40,
    "usTradeIndex": 37,
    "usAidIndex": 20,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 56,
      "economic": 51,
      "military": 49,
      "intelligence": 76,
      "trust": 41,
      "foreignPublicOpinion": 69,
      "dependency": 44,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-py",
      "countryId": "py",
      "label": "Mission américaine — Paraguay",
      "status": "open",
      "city": "Asunción",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 82,
      "accessIndex": 62,
      "consularCapacityIndex": 43,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pe",
    "iso2": "PE",
    "name": "Pérou",
    "capital": "Lima",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 30.81,
    "economicIndex": 67,
    "militaryIndex": 61,
    "usTradeIndex": 66,
    "usAidIndex": 43,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 65,
      "economic": 60,
      "military": 58,
      "intelligence": 36,
      "trust": 50,
      "foreignPublicOpinion": 29,
      "dependency": 53,
      "tension": 26
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-pe",
      "countryId": "pe",
      "label": "Mission américaine — Pérou",
      "status": "open",
      "city": "Lima",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 79,
      "accessIndex": 74,
      "consularCapacityIndex": 46,
      "securityIndex": 69,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.88,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ph",
    "iso2": "PH",
    "name": "Philippines",
    "capital": "Manila",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 44
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 100.7,
    "economicIndex": 73,
    "militaryIndex": 67,
    "usTradeIndex": 72,
    "usAidIndex": 49,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 71,
      "economic": 66,
      "military": 64,
      "intelligence": 42,
      "trust": 56,
      "foreignPublicOpinion": 35,
      "dependency": 59,
      "tension": 32
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Alliance / traité de sécurité US"
    ],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ph",
      "countryId": "ph",
      "label": "Mission américaine — Philippines",
      "status": "open",
      "city": "Manila",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 80,
      "consularCapacityIndex": 52,
      "securityIndex": 75,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pl",
    "iso2": "PL",
    "name": "Pologne",
    "capital": "Warsaw",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 14
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 38.5,
    "economicIndex": 81,
    "militaryIndex": 75,
    "usTradeIndex": 80,
    "usAidIndex": 57,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 30,
      "economic": 74,
      "military": 72,
      "intelligence": 50,
      "trust": 64,
      "foreignPublicOpinion": 43,
      "dependency": 67,
      "tension": 40
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-pl",
      "countryId": "pl",
      "label": "Mission américaine — Pologne",
      "status": "open",
      "city": "Warsaw",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 56,
      "accessIndex": 36,
      "consularCapacityIndex": 60,
      "securityIndex": 83,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.61,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "pt",
    "iso2": "PT",
    "name": "Portugal",
    "capital": "Lisbon",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.48,
    "economicIndex": 47,
    "militaryIndex": 30,
    "usTradeIndex": 27,
    "usAidIndex": 10,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 46,
      "economic": 41,
      "military": 39,
      "intelligence": 66,
      "trust": 31,
      "foreignPublicOpinion": 59,
      "dependency": 34,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-pt",
      "countryId": "pt",
      "label": "Mission américaine — Portugal",
      "status": "open",
      "city": "Lisbon",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 52,
      "consularCapacityIndex": 76,
      "securityIndex": 50,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "qa",
    "iso2": "QA",
    "name": "Qatar",
    "capital": "Doha",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.27,
    "economicIndex": 60,
    "militaryIndex": 54,
    "usTradeIndex": 59,
    "usAidIndex": 36,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 58,
      "economic": 53,
      "military": 51,
      "intelligence": 29,
      "trust": 43,
      "foreignPublicOpinion": 71,
      "dependency": 46,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-qa",
      "countryId": "qa",
      "label": "Mission américaine — Qatar",
      "status": "open",
      "city": "Doha",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 67,
      "consularCapacityIndex": 82,
      "securityIndex": 62,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kr",
    "iso2": "KR",
    "name": "Corée du Sud",
    "capital": "Seoul",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 50.42,
    "economicIndex": 38,
    "militaryIndex": 21,
    "usTradeIndex": 72,
    "usAidIndex": 1,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 88,
      "economic": 86,
      "military": 88,
      "intelligence": 80,
      "trust": 82,
      "foreignPublicOpinion": 66,
      "dependency": 66,
      "tension": 20
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Alliance / traité de sécurité US"
    ],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-kr",
      "countryId": "kr",
      "label": "Mission américaine — Corée du Sud",
      "status": "open",
      "city": "Seoul",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 43,
      "consularCapacityIndex": 67,
      "securityIndex": 41,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ro",
    "iso2": "RO",
    "name": "Roumanie",
    "capital": "Bucharest",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 22
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 19.94,
    "economicIndex": 39,
    "militaryIndex": 22,
    "usTradeIndex": 19,
    "usAidIndex": 2,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 38,
      "economic": 33,
      "military": 31,
      "intelligence": 58,
      "trust": 72,
      "foreignPublicOpinion": 51,
      "dependency": 75,
      "tension": 48
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-ro",
      "countryId": "ro",
      "label": "Mission américaine — Roumanie",
      "status": "open",
      "city": "Bucharest",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 44,
      "consularCapacityIndex": 68,
      "securityIndex": 42,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.69,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ru",
    "iso2": "RU",
    "name": "Russie",
    "capital": "Moscow",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Vladimir Putin",
      "title": "Président de la Fédération de Russie",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Kremlin — structure du Président, consulté 18/09/2026",
      "successionRiskIndex": 22
    },
    "regimeLabel": "République fédérale à présidence forte",
    "populationMillions": 146.23,
    "economicIndex": 51,
    "militaryIndex": 34,
    "usTradeIndex": 31,
    "usAidIndex": 14,
    "sanctionsLevel": 88,
    "usBaseAccessIndex": 27,
    "relation": {
      "diplomatic": 24,
      "economic": 20,
      "military": 14,
      "intelligence": 10,
      "trust": 12,
      "foreignPublicOpinion": 24,
      "dependency": 28,
      "tension": 86
    },
    "dependencies": [
      "énergie mondiale",
      "matières premières",
      "sécurité euro-atlantique"
    ],
    "disputes": [
      "Guerre en Ukraine et sécurité euro-atlantique",
      "Sanctions et contrôles export",
      "Cybersécurité et renseignement",
      "Architecture de sécurité européenne"
    ],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20",
      "CSNU-P5"
    ],
    "mission": {
      "id": "mission-ru",
      "countryId": "ru",
      "label": "Mission américaine — Russie",
      "status": "open",
      "city": "Moscow",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 76,
      "accessIndex": 56,
      "consularCapacityIndex": 80,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "rw",
    "iso2": "RW",
    "name": "Rwanda",
    "capital": "Kigali",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 11.0,
    "economicIndex": 55,
    "militaryIndex": 38,
    "usTradeIndex": 35,
    "usAidIndex": 18,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-rw",
      "countryId": "rw",
      "label": "Mission américaine — Rwanda",
      "status": "open",
      "city": "Kigali",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 60,
      "consularCapacityIndex": 84,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "kn",
    "iso2": "KN",
    "name": "Saint-Christophe-et-Niévès",
    "capital": "Basseterre",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 13
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.06,
    "economicIndex": 80,
    "militaryIndex": 74,
    "usTradeIndex": 79,
    "usAidIndex": 56,
    "sanctionsLevel": 18,
    "usBaseAccessIndex": 6,
    "relation": {
      "diplomatic": 29,
      "economic": 73,
      "military": 71,
      "intelligence": 49,
      "trust": 63,
      "foreignPublicOpinion": 42,
      "dependency": 66,
      "tension": 39
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-kn",
      "countryId": "kn",
      "label": "Mission américaine — Saint-Christophe-et-Niévès",
      "status": "handling_post",
      "city": "Basseterre",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 55,
      "accessIndex": 35,
      "consularCapacityIndex": 59,
      "securityIndex": 82,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.6,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lc",
    "iso2": "LC",
    "name": "Sainte-Lucie",
    "capital": "Castries",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.18,
    "economicIndex": 59,
    "militaryIndex": 53,
    "usTradeIndex": 58,
    "usAidIndex": 35,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 57,
      "economic": 52,
      "military": 50,
      "intelligence": 28,
      "trust": 42,
      "foreignPublicOpinion": 70,
      "dependency": 45,
      "tension": 18
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-lc",
      "countryId": "lc",
      "label": "Mission américaine — Sainte-Lucie",
      "status": "handling_post",
      "city": "Castries",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 71,
      "accessIndex": 66,
      "consularCapacityIndex": 81,
      "securityIndex": 61,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "vc",
    "iso2": "VC",
    "name": "Saint-Vincent-et-les Grenadines",
    "capital": "Kingstown",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.11,
    "economicIndex": 69,
    "militaryIndex": 63,
    "usTradeIndex": 68,
    "usAidIndex": 45,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 67,
      "economic": 62,
      "military": 60,
      "intelligence": 38,
      "trust": 52,
      "foreignPublicOpinion": 31,
      "dependency": 55,
      "tension": 28
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-vc",
      "countryId": "vc",
      "label": "Mission américaine — Saint-Vincent-et-les Grenadines",
      "status": "handling_post",
      "city": "Kingstown",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 81,
      "accessIndex": 76,
      "consularCapacityIndex": 48,
      "securityIndex": 71,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.49,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ws",
    "iso2": "WS",
    "name": "Samoa",
    "capital": "Apia",
    "region": "Oceania",
    "subregion": "Polynesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 35
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.19,
    "economicIndex": 52,
    "militaryIndex": 35,
    "usTradeIndex": 32,
    "usAidIndex": 15,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 51,
      "economic": 46,
      "military": 44,
      "intelligence": 71,
      "trust": 36,
      "foreignPublicOpinion": 64,
      "dependency": 39,
      "tension": 61
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ws",
      "countryId": "ws",
      "label": "Mission américaine — Samoa",
      "status": "open",
      "city": "Apia",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 57,
      "consularCapacityIndex": 81,
      "securityIndex": 55,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.82,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sm",
    "iso2": "SM",
    "name": "Saint-Marin",
    "capital": "City of San Marino",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 19
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.03,
    "economicIndex": 36,
    "militaryIndex": 80,
    "usTradeIndex": 16,
    "usAidIndex": 62,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 12,
    "relation": {
      "diplomatic": 35,
      "economic": 30,
      "military": 28,
      "intelligence": 55,
      "trust": 69,
      "foreignPublicOpinion": 48,
      "dependency": 72,
      "tension": 45
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sm",
      "countryId": "sm",
      "label": "Mission américaine — Saint-Marin",
      "status": "handling_post",
      "city": "City of San Marino",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 61,
      "accessIndex": 41,
      "consularCapacityIndex": 65,
      "securityIndex": 88,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.66,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "st",
    "iso2": "ST",
    "name": "Sao Tomé-et-Principe",
    "capital": "São Tomé",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.19,
    "economicIndex": 50,
    "militaryIndex": 33,
    "usTradeIndex": 30,
    "usAidIndex": 13,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 49,
      "economic": 44,
      "military": 42,
      "intelligence": 69,
      "trust": 34,
      "foreignPublicOpinion": 62,
      "dependency": 37,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-st",
      "countryId": "st",
      "label": "Mission américaine — Sao Tomé-et-Principe",
      "status": "handling_post",
      "city": "São Tomé",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 75,
      "accessIndex": 55,
      "consularCapacityIndex": 79,
      "securityIndex": 53,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sa",
    "iso2": "SA",
    "name": "Arabie saoudite",
    "capital": "Riyadh",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 33
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 30.77,
    "economicIndex": 62,
    "militaryIndex": 56,
    "usTradeIndex": 61,
    "usAidIndex": 38,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 60,
      "economic": 55,
      "military": 53,
      "intelligence": 31,
      "trust": 45,
      "foreignPublicOpinion": 73,
      "dependency": 48,
      "tension": 21
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-sa",
      "countryId": "sa",
      "label": "Mission américaine — Arabie saoudite",
      "status": "open",
      "city": "Riyadh",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 74,
      "accessIndex": 69,
      "consularCapacityIndex": 84,
      "securityIndex": 64,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.83,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sn",
    "iso2": "SN",
    "name": "Sénégal",
    "capital": "Dakar",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 21
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 13.51,
    "economicIndex": 38,
    "militaryIndex": 21,
    "usTradeIndex": 18,
    "usAidIndex": 1,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 14,
    "relation": {
      "diplomatic": 37,
      "economic": 32,
      "military": 30,
      "intelligence": 57,
      "trust": 71,
      "foreignPublicOpinion": 50,
      "dependency": 74,
      "tension": 47
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sn",
      "countryId": "sn",
      "label": "Mission américaine — Sénégal",
      "status": "open",
      "city": "Dakar",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 63,
      "accessIndex": 43,
      "consularCapacityIndex": 67,
      "securityIndex": 41,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.68,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "rs",
    "iso2": "RS",
    "name": "Serbie",
    "capital": "Belgrade",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 7.19,
    "economicIndex": 47,
    "militaryIndex": 30,
    "usTradeIndex": 27,
    "usAidIndex": 10,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 46,
      "economic": 41,
      "military": 39,
      "intelligence": 66,
      "trust": 31,
      "foreignPublicOpinion": 59,
      "dependency": 34,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-rs",
      "countryId": "rs",
      "label": "Mission américaine — Serbie",
      "status": "open",
      "city": "Belgrade",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 52,
      "consularCapacityIndex": 76,
      "securityIndex": 50,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sc",
    "iso2": "SC",
    "name": "Seychelles",
    "capital": "Victoria",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 37
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.09,
    "economicIndex": 66,
    "militaryIndex": 60,
    "usTradeIndex": 65,
    "usAidIndex": 42,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 64,
      "economic": 59,
      "military": 57,
      "intelligence": 35,
      "trust": 49,
      "foreignPublicOpinion": 28,
      "dependency": 52,
      "tension": 25
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sc",
      "countryId": "sc",
      "label": "Mission américaine — Seychelles",
      "status": "handling_post",
      "city": "Victoria",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 78,
      "accessIndex": 73,
      "consularCapacityIndex": 45,
      "securityIndex": 68,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sl",
    "iso2": "SL",
    "name": "Sierra Leone",
    "capital": "Freetown",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.21,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 33,
      "economic": 28,
      "military": 75,
      "intelligence": 53,
      "trust": 67,
      "foreignPublicOpinion": 46,
      "dependency": 70,
      "tension": 43
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sl",
      "countryId": "sl",
      "label": "Mission américaine — Sierra Leone",
      "status": "open",
      "city": "Freetown",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sg",
    "iso2": "SG",
    "name": "Singapour",
    "capital": "Singapore",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 45
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.47,
    "economicIndex": 74,
    "militaryIndex": 68,
    "usTradeIndex": 73,
    "usAidIndex": 50,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 0,
    "relation": {
      "diplomatic": 72,
      "economic": 67,
      "military": 65,
      "intelligence": 43,
      "trust": 57,
      "foreignPublicOpinion": 36,
      "dependency": 60,
      "tension": 33
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sg",
      "countryId": "sg",
      "label": "Mission américaine — Singapour",
      "status": "open",
      "city": "Singapore",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 49,
      "accessIndex": 81,
      "consularCapacityIndex": 53,
      "securityIndex": 76,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.54,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sk",
    "iso2": "SK",
    "name": "Slovaquie",
    "capital": "Bratislava",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 15
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.42,
    "economicIndex": 82,
    "militaryIndex": 76,
    "usTradeIndex": 12,
    "usAidIndex": 58,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 8,
    "relation": {
      "diplomatic": 31,
      "economic": 75,
      "military": 73,
      "intelligence": 51,
      "trust": 65,
      "foreignPublicOpinion": 44,
      "dependency": 68,
      "tension": 41
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-sk",
      "countryId": "sk",
      "label": "Mission américaine — Slovaquie",
      "status": "open",
      "city": "Bratislava",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 57,
      "accessIndex": 37,
      "consularCapacityIndex": 61,
      "securityIndex": 84,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.62,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "si",
    "iso2": "SI",
    "name": "Slovénie",
    "capital": "Ljubljana",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 11
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 2.06,
    "economicIndex": 78,
    "militaryIndex": 72,
    "usTradeIndex": 77,
    "usAidIndex": 54,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 76,
      "economic": 71,
      "military": 69,
      "intelligence": 47,
      "trust": 61,
      "foreignPublicOpinion": 40,
      "dependency": 64,
      "tension": 37
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-si",
      "countryId": "si",
      "label": "Mission américaine — Slovénie",
      "status": "open",
      "city": "Ljubljana",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 53,
      "accessIndex": 85,
      "consularCapacityIndex": 57,
      "securityIndex": 80,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.58,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sb",
    "iso2": "SB",
    "name": "Îles Salomon",
    "capital": "Honiara",
    "region": "Oceania",
    "subregion": "Melanesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 35
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.58,
    "economicIndex": 64,
    "militaryIndex": 58,
    "usTradeIndex": 63,
    "usAidIndex": 40,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 62,
      "economic": 57,
      "military": 55,
      "intelligence": 33,
      "trust": 47,
      "foreignPublicOpinion": 75,
      "dependency": 50,
      "tension": 23
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sb",
      "countryId": "sb",
      "label": "Mission américaine — Îles Salomon",
      "status": "handling_post",
      "city": "Honiara",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 76,
      "accessIndex": 71,
      "consularCapacityIndex": 43,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "so",
    "iso2": "SO",
    "name": "Somalie",
    "capital": "Mogadishu",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.81,
    "economicIndex": 40,
    "militaryIndex": 23,
    "usTradeIndex": 20,
    "usAidIndex": 3,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 16,
    "relation": {
      "diplomatic": 39,
      "economic": 34,
      "military": 32,
      "intelligence": 59,
      "trust": 73,
      "foreignPublicOpinion": 52,
      "dependency": 76,
      "tension": 49
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-so",
      "countryId": "so",
      "label": "Mission américaine — Somalie",
      "status": "open",
      "city": "Mogadishu",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 65,
      "accessIndex": 45,
      "consularCapacityIndex": 69,
      "securityIndex": 43,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.7,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "za",
    "iso2": "ZA",
    "name": "Afrique du Sud",
    "capital": "Pretoria",
    "region": "Africa",
    "subregion": "Southern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 40
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 54.0,
    "economicIndex": 69,
    "militaryIndex": 63,
    "usTradeIndex": 68,
    "usAidIndex": 45,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 67,
      "economic": 62,
      "military": 60,
      "intelligence": 38,
      "trust": 52,
      "foreignPublicOpinion": 31,
      "dependency": 55,
      "tension": 28
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU",
      "G20"
    ],
    "mission": {
      "id": "mission-za",
      "countryId": "za",
      "label": "Mission américaine — Afrique du Sud",
      "status": "open",
      "city": "Pretoria",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 81,
      "accessIndex": 76,
      "consularCapacityIndex": 48,
      "securityIndex": 71,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.49,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ss",
    "iso2": "SS",
    "name": "Soudan du Sud",
    "capital": "Juba",
    "region": "Africa",
    "subregion": "Middle Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 11.38,
    "economicIndex": 48,
    "militaryIndex": 31,
    "usTradeIndex": 28,
    "usAidIndex": 11,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 24,
    "relation": {
      "diplomatic": 47,
      "economic": 42,
      "military": 40,
      "intelligence": 67,
      "trust": 32,
      "foreignPublicOpinion": 60,
      "dependency": 35,
      "tension": 57
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ss",
      "countryId": "ss",
      "label": "Mission américaine — Soudan du Sud",
      "status": "open",
      "city": "Juba",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 73,
      "accessIndex": 53,
      "consularCapacityIndex": 77,
      "securityIndex": 51,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.78,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "es",
    "iso2": "ES",
    "name": "Espagne",
    "capital": "Madrid",
    "region": "Europe",
    "subregion": "Southern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 17
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 46.51,
    "economicIndex": 84,
    "militaryIndex": 78,
    "usTradeIndex": 14,
    "usAidIndex": 60,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 33,
      "economic": 28,
      "military": 75,
      "intelligence": 53,
      "trust": 67,
      "foreignPublicOpinion": 46,
      "dependency": 70,
      "tension": 43
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-es",
      "countryId": "es",
      "label": "Mission américaine — Espagne",
      "status": "open",
      "city": "Madrid",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 59,
      "accessIndex": 39,
      "consularCapacityIndex": 63,
      "securityIndex": 86,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.64,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "lk",
    "iso2": "LK",
    "name": "Sri Lanka",
    "capital": "Colombo",
    "region": "Asia",
    "subregion": "Southern Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 8
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 20.28,
    "economicIndex": 75,
    "militaryIndex": 69,
    "usTradeIndex": 74,
    "usAidIndex": 51,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 73,
      "economic": 68,
      "military": 66,
      "intelligence": 44,
      "trust": 58,
      "foreignPublicOpinion": 37,
      "dependency": 61,
      "tension": 34
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-lk",
      "countryId": "lk",
      "label": "Mission américaine — Sri Lanka",
      "status": "open",
      "city": "Colombo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 50,
      "accessIndex": 82,
      "consularCapacityIndex": 54,
      "securityIndex": 77,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.55,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sd",
    "iso2": "SD",
    "name": "Soudan",
    "capital": "Khartoum",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 39
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 37.29,
    "economicIndex": 68,
    "militaryIndex": 62,
    "usTradeIndex": 67,
    "usAidIndex": 44,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 23,
    "relation": {
      "diplomatic": 66,
      "economic": 61,
      "military": 59,
      "intelligence": 37,
      "trust": 51,
      "foreignPublicOpinion": 30,
      "dependency": 54,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sd",
      "countryId": "sd",
      "label": "Mission américaine — Soudan",
      "status": "open",
      "city": "Khartoum",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 80,
      "accessIndex": 75,
      "consularCapacityIndex": 47,
      "securityIndex": 70,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.48,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sr",
    "iso2": "SR",
    "name": "Suriname",
    "capital": "Paramaribo",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 29
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.53,
    "economicIndex": 46,
    "militaryIndex": 29,
    "usTradeIndex": 26,
    "usAidIndex": 9,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 22,
    "relation": {
      "diplomatic": 45,
      "economic": 40,
      "military": 38,
      "intelligence": 65,
      "trust": 30,
      "foreignPublicOpinion": 58,
      "dependency": 33,
      "tension": 55
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sr",
      "countryId": "sr",
      "label": "Mission américaine — Suriname",
      "status": "open",
      "city": "Paramaribo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 71,
      "accessIndex": 51,
      "consularCapacityIndex": 75,
      "securityIndex": 49,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.76,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "se",
    "iso2": "SE",
    "name": "Suède",
    "capital": "Stockholm",
    "region": "Europe",
    "subregion": "Northern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 41
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.74,
    "economicIndex": 70,
    "militaryIndex": 64,
    "usTradeIndex": 69,
    "usAidIndex": 46,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 25,
    "relation": {
      "diplomatic": 68,
      "economic": 63,
      "military": 61,
      "intelligence": 39,
      "trust": 53,
      "foreignPublicOpinion": 32,
      "dependency": 56,
      "tension": 29
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "UE"
    ],
    "mission": {
      "id": "mission-se",
      "countryId": "se",
      "label": "Mission américaine — Suède",
      "status": "open",
      "city": "Stockholm",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 82,
      "accessIndex": 77,
      "consularCapacityIndex": 49,
      "securityIndex": 72,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.5,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ch",
    "iso2": "CH",
    "name": "Suisse",
    "capital": "Bern",
    "region": "Europe",
    "subregion": "Western Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 31
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 8.18,
    "economicIndex": 60,
    "militaryIndex": 54,
    "usTradeIndex": 59,
    "usAidIndex": 36,
    "sanctionsLevel": 17,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 58,
      "economic": 53,
      "military": 51,
      "intelligence": 29,
      "trust": 43,
      "foreignPublicOpinion": 71,
      "dependency": 46,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ch",
      "countryId": "ch",
      "label": "Mission américaine — Suisse",
      "status": "open",
      "city": "Bern",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 67,
      "consularCapacityIndex": 82,
      "securityIndex": 62,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "sy",
    "iso2": "SY",
    "name": "Syrie",
    "capital": "Damascus",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 43
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 22.96,
    "economicIndex": 60,
    "militaryIndex": 43,
    "usTradeIndex": 40,
    "usAidIndex": 23,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 59,
      "economic": 54,
      "military": 52,
      "intelligence": 30,
      "trust": 44,
      "foreignPublicOpinion": 72,
      "dependency": 47,
      "tension": 24
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-sy",
      "countryId": "sy",
      "label": "Mission américaine — Syrie",
      "status": "open",
      "city": "Damascus",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 65,
      "consularCapacityIndex": 46,
      "securityIndex": 63,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.49,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tj",
    "iso2": "TJ",
    "name": "Tadjikistan",
    "capital": "Dushanbe",
    "region": "Asia",
    "subregion": "Central Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 14
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 8.16,
    "economicIndex": 81,
    "militaryIndex": 75,
    "usTradeIndex": 80,
    "usAidIndex": 57,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 30,
      "economic": 74,
      "military": 72,
      "intelligence": 50,
      "trust": 64,
      "foreignPublicOpinion": 43,
      "dependency": 67,
      "tension": 40
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tj",
      "countryId": "tj",
      "label": "Mission américaine — Tadjikistan",
      "status": "open",
      "city": "Dushanbe",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 56,
      "accessIndex": 36,
      "consularCapacityIndex": 60,
      "securityIndex": 83,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.61,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tz",
    "iso2": "TZ",
    "name": "Tanzanie",
    "capital": "Dodoma",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 8
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 47.42,
    "economicIndex": 63,
    "militaryIndex": 46,
    "usTradeIndex": 43,
    "usAidIndex": 26,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 62,
      "economic": 57,
      "military": 55,
      "intelligence": 33,
      "trust": 47,
      "foreignPublicOpinion": 75,
      "dependency": 50,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tz",
      "countryId": "tz",
      "label": "Mission américaine — Tanzanie",
      "status": "open",
      "city": "Dodoma",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 68,
      "consularCapacityIndex": 49,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.52,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "th",
    "iso2": "TH",
    "name": "Thaïlande",
    "capital": "Bangkok",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 10
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 64.87,
    "economicIndex": 77,
    "militaryIndex": 71,
    "usTradeIndex": 76,
    "usAidIndex": 53,
    "sanctionsLevel": 15,
    "usBaseAccessIndex": 3,
    "relation": {
      "diplomatic": 75,
      "economic": 70,
      "military": 68,
      "intelligence": 46,
      "trust": 60,
      "foreignPublicOpinion": 39,
      "dependency": 63,
      "tension": 36
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Alliance / traité de sécurité US"
    ],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-th",
      "countryId": "th",
      "label": "Mission américaine — Thaïlande",
      "status": "open",
      "city": "Bangkok",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 52,
      "accessIndex": 84,
      "consularCapacityIndex": 56,
      "securityIndex": 79,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.57,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tl",
    "iso2": "TL",
    "name": "Timor oriental",
    "capital": "Dili",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 18
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.17,
    "economicIndex": 35,
    "militaryIndex": 79,
    "usTradeIndex": 15,
    "usAidIndex": 61,
    "sanctionsLevel": 4,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 34,
      "economic": 29,
      "military": 76,
      "intelligence": 54,
      "trust": 68,
      "foreignPublicOpinion": 47,
      "dependency": 71,
      "tension": 44
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tl",
      "countryId": "tl",
      "label": "Mission américaine — Timor oriental",
      "status": "open",
      "city": "Dili",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 60,
      "accessIndex": 40,
      "consularCapacityIndex": 64,
      "securityIndex": 87,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.65,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tg",
    "iso2": "TG",
    "name": "Togo",
    "capital": "Lomé",
    "region": "Africa",
    "subregion": "Western Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 8
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 6.99,
    "economicIndex": 75,
    "militaryIndex": 69,
    "usTradeIndex": 74,
    "usAidIndex": 51,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 1,
    "relation": {
      "diplomatic": 73,
      "economic": 68,
      "military": 66,
      "intelligence": 44,
      "trust": 58,
      "foreignPublicOpinion": 37,
      "dependency": 61,
      "tension": 34
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tg",
      "countryId": "tg",
      "label": "Mission américaine — Togo",
      "status": "open",
      "city": "Lomé",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 50,
      "accessIndex": 82,
      "consularCapacityIndex": 54,
      "securityIndex": 77,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.55,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "to",
    "iso2": "TO",
    "name": "Tonga",
    "capital": "Nuku'alofa",
    "region": "Oceania",
    "subregion": "Polynesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.1,
    "economicIndex": 41,
    "militaryIndex": 24,
    "usTradeIndex": 21,
    "usAidIndex": 4,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 40,
      "economic": 35,
      "military": 33,
      "intelligence": 60,
      "trust": 74,
      "foreignPublicOpinion": 53,
      "dependency": 28,
      "tension": 50
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-to",
      "countryId": "to",
      "label": "Mission américaine — Tonga",
      "status": "handling_post",
      "city": "Nuku'alofa",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 66,
      "accessIndex": 46,
      "consularCapacityIndex": 70,
      "securityIndex": 44,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tt",
    "iso2": "TT",
    "name": "Trinité-et-Tobago",
    "capital": "Port of Spain",
    "region": "Americas",
    "subregion": "Caribbean",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 34
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 1.33,
    "economicIndex": 51,
    "militaryIndex": 34,
    "usTradeIndex": 31,
    "usAidIndex": 14,
    "sanctionsLevel": 1,
    "usBaseAccessIndex": 27,
    "relation": {
      "diplomatic": 50,
      "economic": 45,
      "military": 43,
      "intelligence": 70,
      "trust": 35,
      "foreignPublicOpinion": 63,
      "dependency": 38,
      "tension": 60
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tt",
      "countryId": "tt",
      "label": "Mission américaine — Trinité-et-Tobago",
      "status": "open",
      "city": "Port of Spain",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 76,
      "accessIndex": 56,
      "consularCapacityIndex": 80,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.81,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tn",
    "iso2": "TN",
    "name": "Tunisie",
    "capital": "Tunis",
    "region": "Africa",
    "subregion": "Northern Africa",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 22
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 10.98,
    "economicIndex": 39,
    "militaryIndex": 22,
    "usTradeIndex": 19,
    "usAidIndex": 2,
    "sanctionsLevel": 8,
    "usBaseAccessIndex": 15,
    "relation": {
      "diplomatic": 38,
      "economic": 33,
      "military": 31,
      "intelligence": 58,
      "trust": 72,
      "foreignPublicOpinion": 51,
      "dependency": 75,
      "tension": 48
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tn",
      "countryId": "tn",
      "label": "Mission américaine — Tunisie",
      "status": "open",
      "city": "Tunis",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 44,
      "consularCapacityIndex": 68,
      "securityIndex": 42,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.69,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tr",
    "iso2": "TR",
    "name": "Türkiye",
    "capital": "Ankara",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 30
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 76.67,
    "economicIndex": 47,
    "militaryIndex": 30,
    "usTradeIndex": 27,
    "usAidIndex": 10,
    "sanctionsLevel": 16,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 46,
      "economic": 41,
      "military": 39,
      "intelligence": 66,
      "trust": 31,
      "foreignPublicOpinion": 59,
      "dependency": 34,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "G20"
    ],
    "mission": {
      "id": "mission-tr",
      "countryId": "tr",
      "label": "Mission américaine — Türkiye",
      "status": "open",
      "city": "Ankara",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 72,
      "accessIndex": 52,
      "consularCapacityIndex": 76,
      "securityIndex": 50,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.77,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tm",
    "iso2": "TM",
    "name": "Turkménistan",
    "capital": "Ashgabat",
    "region": "Asia",
    "subregion": "Central Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 20
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 5.84,
    "economicIndex": 37,
    "militaryIndex": 20,
    "usTradeIndex": 17,
    "usAidIndex": 0,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 36,
      "economic": 31,
      "military": 29,
      "intelligence": 56,
      "trust": 70,
      "foreignPublicOpinion": 49,
      "dependency": 73,
      "tension": 46
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tm",
      "countryId": "tm",
      "label": "Mission américaine — Turkménistan",
      "status": "open",
      "city": "Ashgabat",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 62,
      "accessIndex": 42,
      "consularCapacityIndex": 66,
      "securityIndex": 40,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.67,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tv",
    "iso2": "TV",
    "name": "Tuvalu",
    "capital": "Funafuti",
    "region": "Oceania",
    "subregion": "Polynesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.01,
    "economicIndex": 55,
    "militaryIndex": 38,
    "usTradeIndex": 35,
    "usAidIndex": 18,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-tv",
      "countryId": "tv",
      "label": "Mission américaine — Tuvalu",
      "status": "handling_post",
      "city": "Funafuti",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 80,
      "accessIndex": 60,
      "consularCapacityIndex": 84,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ug",
    "iso2": "UG",
    "name": "Ouganda",
    "capital": "Kampala",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 9
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 34.86,
    "economicIndex": 76,
    "militaryIndex": 70,
    "usTradeIndex": 75,
    "usAidIndex": 52,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 74,
      "economic": 69,
      "military": 67,
      "intelligence": 45,
      "trust": 59,
      "foreignPublicOpinion": 38,
      "dependency": 62,
      "tension": 35
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ug",
      "countryId": "ug",
      "label": "Mission américaine — Ouganda",
      "status": "open",
      "city": "Kampala",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 83,
      "consularCapacityIndex": 55,
      "securityIndex": 78,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.56,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ua",
    "iso2": "UA",
    "name": "Ukraine",
    "capital": "Kiev",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 35
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 42.97,
    "economicIndex": 64,
    "militaryIndex": 58,
    "usTradeIndex": 63,
    "usAidIndex": 40,
    "sanctionsLevel": 2,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 78,
      "economic": 55,
      "military": 78,
      "intelligence": 68,
      "trust": 72,
      "foreignPublicOpinion": 64,
      "dependency": 42,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ua",
      "countryId": "ua",
      "label": "Mission américaine — Ukraine",
      "status": "open",
      "city": "Kiev",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 76,
      "accessIndex": 71,
      "consularCapacityIndex": 43,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ae",
    "iso2": "AE",
    "name": "Émirats arabes unis",
    "capital": "Abu Dhabi",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 9.45,
    "economicIndex": 52,
    "militaryIndex": 46,
    "usTradeIndex": 51,
    "usAidIndex": 28,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 7,
    "relation": {
      "diplomatic": 50,
      "economic": 45,
      "military": 43,
      "intelligence": 70,
      "trust": 35,
      "foreignPublicOpinion": 63,
      "dependency": 38,
      "tension": 56
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ae",
      "countryId": "ae",
      "label": "Mission américaine — Émirats arabes unis",
      "status": "open",
      "city": "Abu Dhabi",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 59,
      "consularCapacityIndex": 74,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "gb",
    "iso2": "GB",
    "name": "Royaume-Uni",
    "capital": "Non renseignée",
    "region": "Autre",
    "subregion": "Non renseignée",
    "stateBureau": "SPECIAL",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 23
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 52,
    "militaryIndex": 46,
    "usTradeIndex": 72,
    "usAidIndex": 28,
    "sanctionsLevel": 9,
    "usBaseAccessIndex": 58,
    "relation": {
      "diplomatic": 92,
      "economic": 86,
      "military": 92,
      "intelligence": 94,
      "trust": 88,
      "foreignPublicOpinion": 70,
      "dependency": 52,
      "tension": 14
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "G7",
      "G20",
      "CSNU-P5"
    ],
    "mission": {
      "id": "mission-gb",
      "countryId": "gb",
      "label": "Mission américaine — Royaume-Uni",
      "status": "open",
      "city": "Non renseignée",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 64,
      "accessIndex": 59,
      "consularCapacityIndex": 74,
      "securityIndex": 54,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "us",
    "iso2": "US",
    "name": "États-Unis",
    "capital": "Washington D.C.",
    "region": "Americas",
    "subregion": "Northern America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "Président configuré par le joueur",
      "title": "Président des États-Unis",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "État interne du jeu",
      "successionRiskIndex": 4
    },
    "regimeLabel": "République fédérale présidentielle",
    "populationMillions": 319.26,
    "economicIndex": 50,
    "militaryIndex": 33,
    "usTradeIndex": 30,
    "usAidIndex": 13,
    "sanctionsLevel": 0,
    "usBaseAccessIndex": 26,
    "relation": {
      "diplomatic": 49,
      "economic": 44,
      "military": 42,
      "intelligence": 69,
      "trust": 34,
      "foreignPublicOpinion": 62,
      "dependency": 37,
      "tension": 59
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [
      "Allié NATO"
    ],
    "memberships": [
      "ONU",
      "NATO",
      "G7",
      "G20",
      "CSNU-P5"
    ],
    "mission": {
      "id": "mission-us",
      "countryId": "us",
      "label": "Mission américaine — États-Unis",
      "status": "handling_post",
      "city": "Washington D.C.",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 75,
      "accessIndex": 55,
      "consularCapacityIndex": 79,
      "securityIndex": 53,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.8,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "uy",
    "iso2": "UY",
    "name": "Uruguay",
    "capital": "Montevideo",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 45
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 3.4,
    "economicIndex": 62,
    "militaryIndex": 45,
    "usTradeIndex": 42,
    "usAidIndex": 25,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 9,
    "relation": {
      "diplomatic": 61,
      "economic": 56,
      "military": 54,
      "intelligence": 32,
      "trust": 46,
      "foreignPublicOpinion": 74,
      "dependency": 49,
      "tension": 26
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-uy",
      "countryId": "uy",
      "label": "Mission américaine — Uruguay",
      "status": "open",
      "city": "Montevideo",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 50,
      "accessIndex": 67,
      "consularCapacityIndex": 48,
      "securityIndex": 65,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.51,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "uz",
    "iso2": "UZ",
    "name": "Ouzbékistan",
    "capital": "Tashkent",
    "region": "Asia",
    "subregion": "Central Asia",
    "stateBureau": "SCA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 9
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 30.49,
    "economicIndex": 64,
    "militaryIndex": 47,
    "usTradeIndex": 44,
    "usAidIndex": 27,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 11,
    "relation": {
      "diplomatic": 63,
      "economic": 58,
      "military": 56,
      "intelligence": 34,
      "trust": 48,
      "foreignPublicOpinion": 76,
      "dependency": 51,
      "tension": 28
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-uz",
      "countryId": "uz",
      "label": "Mission américaine — Ouzbékistan",
      "status": "open",
      "city": "Tashkent",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 52,
      "accessIndex": 69,
      "consularCapacityIndex": 50,
      "securityIndex": 67,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "vu",
    "iso2": "VU",
    "name": "Vanuatu",
    "capital": "Port Vila",
    "region": "Oceania",
    "subregion": "Melanesia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 38
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 0.26,
    "economicIndex": 55,
    "militaryIndex": 38,
    "usTradeIndex": 35,
    "usAidIndex": 18,
    "sanctionsLevel": 5,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 54,
      "economic": 49,
      "military": 47,
      "intelligence": 74,
      "trust": 39,
      "foreignPublicOpinion": 67,
      "dependency": 42,
      "tension": 19
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-vu",
      "countryId": "vu",
      "label": "Mission américaine — Vanuatu",
      "status": "handling_post",
      "city": "Port Vila",
      "chiefOfMission": "Aucun ambassadeur américain résident",
      "chiefStatus": "charge_d_affaires",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 80,
      "accessIndex": 60,
      "consularCapacityIndex": 84,
      "securityIndex": 58,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.85,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ve",
    "iso2": "VE",
    "name": "Venezuela",
    "capital": "Caracas",
    "region": "Americas",
    "subregion": "South America",
    "stateBureau": "WHA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 44
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 30.21,
    "economicIndex": 73,
    "militaryIndex": 67,
    "usTradeIndex": 72,
    "usAidIndex": 49,
    "sanctionsLevel": 11,
    "usBaseAccessIndex": 28,
    "relation": {
      "diplomatic": 71,
      "economic": 66,
      "military": 64,
      "intelligence": 42,
      "trust": 56,
      "foreignPublicOpinion": 35,
      "dependency": 59,
      "tension": 32
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ve",
      "countryId": "ve",
      "label": "Mission américaine — Venezuela",
      "status": "open",
      "city": "Caracas",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 48,
      "accessIndex": 80,
      "consularCapacityIndex": 52,
      "securityIndex": 75,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.53,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "vn",
    "iso2": "VN",
    "name": "Viêt Nam",
    "capital": "Hanoi",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 24
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 89.71,
    "economicIndex": 41,
    "militaryIndex": 24,
    "usTradeIndex": 21,
    "usAidIndex": 4,
    "sanctionsLevel": 10,
    "usBaseAccessIndex": 17,
    "relation": {
      "diplomatic": 40,
      "economic": 35,
      "military": 33,
      "intelligence": 60,
      "trust": 74,
      "foreignPublicOpinion": 53,
      "dependency": 28,
      "tension": 50
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-vn",
      "countryId": "vn",
      "label": "Mission américaine — Viêt Nam",
      "status": "open",
      "city": "Hanoi",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 66,
      "accessIndex": 46,
      "consularCapacityIndex": 70,
      "securityIndex": 44,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.71,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ye",
    "iso2": "YE",
    "name": "Yémen",
    "capital": "Sana'a",
    "region": "Asia",
    "subregion": "Western Asia",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 9
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 25.96,
    "economicIndex": 76,
    "militaryIndex": 70,
    "usTradeIndex": 75,
    "usAidIndex": 52,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 2,
    "relation": {
      "diplomatic": 74,
      "economic": 69,
      "military": 67,
      "intelligence": 45,
      "trust": 59,
      "foreignPublicOpinion": 38,
      "dependency": 62,
      "tension": 35
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-ye",
      "countryId": "ye",
      "label": "Mission américaine — Yémen",
      "status": "open",
      "city": "Sana'a",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 83,
      "consularCapacityIndex": 55,
      "securityIndex": 78,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.56,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "zm",
    "iso2": "ZM",
    "name": "Zambie",
    "capital": "Lusaka",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 26
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 15.02,
    "economicIndex": 43,
    "militaryIndex": 26,
    "usTradeIndex": 23,
    "usAidIndex": 6,
    "sanctionsLevel": 12,
    "usBaseAccessIndex": 19,
    "relation": {
      "diplomatic": 42,
      "economic": 37,
      "military": 35,
      "intelligence": 62,
      "trust": 76,
      "foreignPublicOpinion": 55,
      "dependency": 30,
      "tension": 52
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-zm",
      "countryId": "zm",
      "label": "Mission américaine — Zambie",
      "status": "open",
      "city": "Lusaka",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 68,
      "accessIndex": 48,
      "consularCapacityIndex": 72,
      "securityIndex": 46,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.73,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "zw",
    "iso2": "ZW",
    "name": "Zimbabwe",
    "capital": "Harare",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "stateBureau": "AF",
    "sovereigntyStatus": "un_member",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 8
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": 13.06,
    "economicIndex": 63,
    "militaryIndex": 46,
    "usTradeIndex": 43,
    "usAidIndex": 26,
    "sanctionsLevel": 13,
    "usBaseAccessIndex": 10,
    "relation": {
      "diplomatic": 62,
      "economic": 57,
      "military": 55,
      "intelligence": 33,
      "trust": 47,
      "foreignPublicOpinion": 75,
      "dependency": 50,
      "tension": 27
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [
      "ONU"
    ],
    "mission": {
      "id": "mission-zw",
      "countryId": "zw",
      "label": "Mission américaine — Zimbabwe",
      "status": "open",
      "city": "Harare",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 51,
      "accessIndex": 68,
      "consularCapacityIndex": 49,
      "securityIndex": 66,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État membre de l’ONU.",
    "intelligenceConfidence": 0.52,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "ps",
    "iso2": "PS",
    "name": "Palestine",
    "capital": "Ramallah / Jérusalem-Est (statut contesté)",
    "region": "Autre",
    "subregion": "Non renseignée",
    "stateBureau": "NEA",
    "sovereigntyStatus": "un_observer",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 28
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 45,
    "militaryIndex": 28,
    "usTradeIndex": 25,
    "usAidIndex": 8,
    "sanctionsLevel": 14,
    "usBaseAccessIndex": 21,
    "relation": {
      "diplomatic": 44,
      "economic": 39,
      "military": 37,
      "intelligence": 64,
      "trust": 29,
      "foreignPublicOpinion": 57,
      "dependency": 32,
      "tension": 54
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [],
    "mission": {
      "id": "mission-ps",
      "countryId": "ps",
      "label": "Mission américaine — Palestine",
      "status": "open",
      "city": "Ramallah / Jérusalem-Est (statut contesté)",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 70,
      "accessIndex": 50,
      "consularCapacityIndex": 74,
      "securityIndex": 48,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État observateur non membre de l’ONU.",
    "intelligenceConfidence": 0.75,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "va",
    "iso2": "VA",
    "name": "Saint-Siège",
    "capital": "Cité du Vatican",
    "region": "Europe",
    "subregion": "Non renseignée",
    "stateBureau": "EUR",
    "sovereigntyStatus": "un_observer",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 36
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 65,
    "militaryIndex": 59,
    "usTradeIndex": 64,
    "usAidIndex": 41,
    "sanctionsLevel": 3,
    "usBaseAccessIndex": 20,
    "relation": {
      "diplomatic": 63,
      "economic": 58,
      "military": 56,
      "intelligence": 34,
      "trust": 48,
      "foreignPublicOpinion": 76,
      "dependency": 51,
      "tension": 24
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [],
    "mission": {
      "id": "mission-va",
      "countryId": "va",
      "label": "Mission américaine — Saint-Siège",
      "status": "open",
      "city": "Cité du Vatican",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 77,
      "accessIndex": 72,
      "consularCapacityIndex": 44,
      "securityIndex": 67,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "État observateur non membre de l’ONU.",
    "intelligenceConfidence": 0.86,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "tw",
    "iso2": "TW",
    "name": "Taïwan",
    "capital": "Taipei",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "stateBureau": "EAP",
    "sovereigntyStatus": "limited_recognition",
    "leader": {
      "name": "Lai Ching-te",
      "title": "Président",
      "verified": true,
      "asOf": "2026-09-18",
      "source": "Office of the President, Taiwan — consulté 18/09/2026",
      "successionRiskIndex": 20
    },
    "regimeLabel": "Démocratie semi-présidentielle; statut international particulier",
    "populationMillions": 23.42,
    "economicIndex": 57,
    "militaryIndex": 40,
    "usTradeIndex": 72,
    "usAidIndex": 20,
    "sanctionsLevel": 7,
    "usBaseAccessIndex": 4,
    "relation": {
      "diplomatic": 72,
      "economic": 82,
      "military": 68,
      "intelligence": 62,
      "trust": 76,
      "foreignPublicOpinion": 70,
      "dependency": 78,
      "tension": 58
    },
    "dependencies": [
      "semi-conducteurs avancés",
      "électronique"
    ],
    "disputes": [
      "Statut diplomatique non officiel",
      "Stabilité du détroit de Taïwan",
      "Semi-conducteurs et chaînes critiques"
    ],
    "allianceTags": [
      "Relation non officielle structurée par le Taiwan Relations Act"
    ],
    "memberships": [],
    "mission": {
      "id": "mission-tw",
      "countryId": "tw",
      "label": "American Institute in Taiwan",
      "status": "unofficial",
      "city": "Taipei",
      "chiefOfMission": "Représentant AIT",
      "chiefStatus": "unofficial_representative",
      "ambassadorConfirmationRequired": false,
      "reportingQualityIndex": 82,
      "accessIndex": 62,
      "consularCapacityIndex": 43,
      "securityIndex": 60,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "Relation américaine non officielle; ne pas afficher comme reconnaissance diplomatique américaine.",
    "intelligenceConfidence": 0.87,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.9,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  },
  {
    "id": "xk",
    "iso2": "XK",
    "name": "Kosovo",
    "capital": "Pristina",
    "region": "Europe",
    "subregion": "Non renseignée",
    "stateBureau": "EUR",
    "sovereigntyStatus": "limited_recognition",
    "leader": {
      "name": "À actualiser au démarrage",
      "title": "Chef d’État / de gouvernement",
      "verified": false,
      "asOf": "2026-09-18",
      "source": "Source institutionnelle locale non vérifiée dans ce seed",
      "successionRiskIndex": 20
    },
    "regimeLabel": "Structure politique nationale — non figée par le seed",
    "populationMillions": null,
    "economicIndex": 37,
    "militaryIndex": 20,
    "usTradeIndex": 17,
    "usAidIndex": 0,
    "sanctionsLevel": 6,
    "usBaseAccessIndex": 13,
    "relation": {
      "diplomatic": 36,
      "economic": 31,
      "military": 29,
      "intelligence": 56,
      "trust": 70,
      "foreignPublicOpinion": 49,
      "dependency": 73,
      "tension": 46
    },
    "dependencies": [],
    "disputes": [],
    "allianceTags": [],
    "memberships": [],
    "mission": {
      "id": "mission-xk",
      "countryId": "xk",
      "label": "Mission américaine — Kosovo",
      "status": "open",
      "city": "Pristina",
      "chiefOfMission": "Chef de mission — scénario initial",
      "chiefStatus": "acting",
      "ambassadorConfirmationRequired": true,
      "reportingQualityIndex": 62,
      "accessIndex": 42,
      "consularCapacityIndex": 66,
      "securityIndex": 40,
      "lastStatusChangeAt": "2026-09-18",
      "source": "Structure de poste initiale — State/FAM + scénario"
    },
    "recognitionNote": "Statut de reconnaissance non universel; traiter explicitement dans la simulation.",
    "intelligenceConfidence": 0.67,
    "updatedAt": "2026-09-18",
    "provenance": {
      "source": "State/ONU + données de structure; repères démographiques historiques pour l’échelle",
      "asOf": "2026-09-18",
      "confidence": 0.72,
      "note": "Les dirigeants non vérifiés restent explicitement marqués. Population = repère historique embarqué, non donnée live; indices économie/défense/opinion = paramètres de simulation."
    },
    "historyIds": []
  }
] as Omit<CountryProfileState,'flow'>[];

const country=(input:Omit<CountryProfileState,'flow'>):CountryProfileState=>({...input,flow:countryFlow});

const org=(id:string,kind:InternationalOrganizationState['kind'],label:string,members:string[],patch:Partial<InternationalOrganizationState>={}):InternationalOrganizationState=>({
  id,kind,label,members,memberStates:members.map((countryId,index)=>({countryId,participationIndex:58+(index%7)*4,contributionIndex:48+(index%9)*5,readinessIndex:55+(index%8)*4,currentPosition:'undecided'})),
  cohesionIndex:68,usInfluenceIndex:72,readinessIndex:70,economicCoordinationIndex:66,sanctionsCoordinationIndex:61,agenda:[],source:'Structure institutionnelle officielle vérifiée au 18/09/2026',referenceDate:REF,...patch
});

const clause=(id:string,kind:any,label:string,us:string,partner:string,funding:number,lag:number)=>({id,kind,label,obligationUS:us,obligationPartner:partner,annualFundingBillions:funding,implementationLagMonths:lag,complianceIndex:80,active:true});
const agreementFlow={...governanceFlow(['State','partenaire','Legal Adviser / Treaty Affairs'],['Defense','Commerce/USTR','Treasury','IC','Congrès','Sénat','moteur international'],['agreement.negotiation.resolve','agreement.ratification.resolve','agreement.monthly'],['SENATE_CONFIRMATION','CONGRESS_REQUIRED','SHARED_AUTHORITY'],'négociation puis procédures juridiques; effets graduels après entrée en vigueur'),historyStore:'international.history'};

export const createInternationalState=():InternationalState=>{
  const countries=RAW_COUNTRIES.map(country);
  for(const c of countries){
    const rich=(c.economicIndex+c.militaryIndex+c.relation.diplomatic)/3;
    c.annualPopulationGrowthPct = c.populationMillions===null?0: c.region==='Africa'?1.9:c.region==='Asia'?0.45:c.region==='Europe'?-0.12:c.region==='Americas'?0.55:0.35;
    c.domesticStabilityIndex = Math.max(18,Math.min(92,Math.round(72-c.leader.successionRiskIndex*.35-c.relation.tension*.12+rich*.12)));
    c.publicOpinionPressureIndex = Math.max(15,Math.min(90,Math.round(35+c.relation.tension*.28+(100-(c.domesticStabilityIndex??60))*.22)));
    c.foreignPolicyOrientation = c.allianceTags.some(x=>x.includes('NATO'))?'alliance_focused':c.militaryIndex>72?'regional_power':c.relation.tension>72?'revisionist':c.relation.diplomatic>62?'status_quo':'nonaligned';
    c.strategicAmbitionIndex = Math.max(15,Math.min(95,Math.round(c.militaryIndex*.45+c.economicIndex*.3+(c.populationMillions??5)/4)));
    c.defenseBudgetIndex = Math.max(10,Math.min(98,Math.round(c.militaryIndex*.72+c.relation.tension*.18)));
  }
  const natoMembers=["al", "be", "bg", "ca", "cz", "de", "dk", "ee", "es", "fi", "fr", "gb", "gr", "hr", "hu", "is", "it", "lt", "lu", "lv", "me", "mk", "nl", "no", "pl", "pt", "ro", "se", "si", "sk", "tr", "us"];
  const euMembers=["at", "be", "bg", "cy", "cz", "de", "dk", "ee", "es", "fi", "fr", "gr", "hr", "hu", "ie", "it", "lt", "lu", "lv", "mt", "nl", "pl", "pt", "ro", "se", "si", "sk"];
  const g7Members=["ca", "de", "fr", "gb", "it", "jp", "us"];
  const g20Members=["ar", "au", "br", "ca", "cn", "de", "fr", "gb", "id", "in", "it", "jp", "kr", "mx", "ru", "sa", "tr", "us", "za"];
  const unMembers=countries.filter(c=>c.sovereigntyStatus==='un_member').map(c=>c.id);
  const organizations:InternationalOrganizationState[]=[
    org('nato','NATO','Organisation du traité de l’Atlantique Nord',natoMembers,{cohesionIndex:76,readinessIndex:78,agenda:['Article 5 et défense collective','readiness','plans et exercices','burden sharing']}),
    org('eu','EU','Union européenne',euMembers,{cohesionIndex:70,economicCoordinationIndex:88,sanctionsCoordinationIndex:74,agenda:['commerce et normes','sanctions','technologie','énergie']}),
    org('un','UN','Organisation des Nations Unies',unMembers,{cohesionIndex:48,usInfluenceIndex:62,readinessIndex:40,economicCoordinationIndex:55,agenda:['Conseil de sécurité','Assemblée générale','missions','diplomatie multilatérale']}),
    org('g7','G7','Groupe des Sept',g7Members,{cohesionIndex:75,economicCoordinationIndex:82,sanctionsCoordinationIndex:78,agenda:['coordination économique','crises','énergie','sécurité économique']}),
    org('g20','G20','Groupe des Vingt',g20Members,{institutionalMembers:['Union européenne','Union africaine'],cohesionIndex:55,economicCoordinationIndex:80,sanctionsCoordinationIndex:45,agenda:['stabilité économique','finance','développement','crises globales']}),
    org('imf','IMF','Fonds monétaire international',unMembers,{cohesionIndex:60,economicCoordinationIndex:90,usInfluenceIndex:68,agenda:['stabilité macroéconomique','programmes et surveillance']}),
    org('world-bank','WORLD_BANK','Groupe de la Banque mondiale',unMembers,{cohesionIndex:62,economicCoordinationIndex:86,usInfluenceIndex:68,agenda:['développement','reconstruction','infrastructures']})
  ];
  const bricsMembers=['br','ru','in','cn','za','eg','et','ir','ae','id','sa'].filter(id=>countries.some(c=>c.id===id));
  const aseanMembers=['bn','kh','id','la','my','mm','ph','sg','th','tl','vn'].filter(id=>countries.some(c=>c.id===id));
  const auMembers=countries.filter(c=>c.region==='Africa'&&c.sovereigntyStatus==='un_member').map(c=>c.id);
  const oasMembers=countries.filter(c=>['North America','South America','Central America','Caribbean','Americas'].includes(c.region)||c.stateBureau==='WHA').filter(c=>c.sovereigntyStatus==='un_member').map(c=>c.id);
  const opecPlusMembers=['dz','cg','gq','ga','ir','iq','kw','ly','ng','sa','ae','ve','az','bh','bn','kz','my','mx','om','ru','sd','ss'].filter(id=>countries.some(c=>c.id===id));
  organizations.push(
    org('brics','BRICS','BRICS',bricsMembers,{cohesionIndex:57,usInfluenceIndex:25,economicCoordinationIndex:72,sanctionsCoordinationIndex:34,agenda:['finance et commerce','coopération Sud-Sud','élargissement','technologie']}),
    org('asean','ASEAN','Association des nations de l’Asie du Sud-Est',aseanMembers,{cohesionIndex:63,usInfluenceIndex:54,economicCoordinationIndex:75,sanctionsCoordinationIndex:28,agenda:['intégration régionale','mer de Chine méridionale','commerce','connectivité']}),
    org('au','AU','Union africaine',auMembers,{institutionalMembers:['République arabe sahraouie démocratique (RASD)'],cohesionIndex:52,usInfluenceIndex:47,economicCoordinationIndex:57,sanctionsCoordinationIndex:31,agenda:['paix et sécurité','intégration continentale','développement','crises régionales']}),
    org('oas','OAS','Organisation des États américains',oasMembers,{cohesionIndex:54,usInfluenceIndex:67,economicCoordinationIndex:50,sanctionsCoordinationIndex:40,agenda:['démocratie','droits humains','sécurité','développement']}),
    org('opec-plus','OPEC_PLUS','OPEP / OPEP+',opecPlusMembers,{cohesionIndex:62,usInfluenceIndex:18,economicCoordinationIndex:86,sanctionsCoordinationIndex:22,agenda:['production pétrolière','stabilité de marché','capacité de réserve','prix énergie']})
  );
  const strategicLocations=[
    {id:'hormuz',label:'Détroit d’Ormuz',kind:'strait',nearCountryIds:['ir','om','ae'],tradeWeight:78,energyWeight:98,navalWeight:92,transitTimeWeight:78,disruptionIndex:12,securityRiskIndex:58,status:'open',note:'Entre Iran et Oman/Émirats; accès du golfe Persique à la mer d’Arabie.'},
    {id:'bab-el-mandeb',label:'Bab el-Mandeb',kind:'strait',nearCountryIds:['ye','dj','er'],tradeWeight:84,energyWeight:76,navalWeight:88,transitTimeWeight:88,disruptionIndex:22,securityRiskIndex:66,status:'open',note:'Entre Yémen et Corne de l’Afrique; relie mer Rouge et golfe d’Aden.'},
    {id:'suez',label:'Canal de Suez',kind:'canal',nearCountryIds:['eg'],controllerCountryId:'eg',tradeWeight:96,energyWeight:82,navalWeight:82,transitTimeWeight:99,disruptionIndex:8,securityRiskIndex:32,status:'open',note:'Égypte; relie Méditerranée et mer Rouge.'},
    {id:'malacca',label:'Détroit de Malacca',kind:'strait',nearCountryIds:['my','id','sg'],tradeWeight:99,energyWeight:84,navalWeight:91,transitTimeWeight:94,disruptionIndex:9,securityRiskIndex:39,status:'open',note:'Entre Malaisie, Indonésie et Singapour; axe majeur océan Indien–Pacifique.'},
    {id:'panama',label:'Canal de Panama',kind:'canal',nearCountryIds:['pa'],controllerCountryId:'pa',tradeWeight:91,energyWeight:58,navalWeight:72,transitTimeWeight:98,disruptionIndex:13,securityRiskIndex:22,status:'open',note:'Panama; relie Atlantique et Pacifique.'},
    {id:'turkish-straits',label:'Détroits turcs',kind:'strait',nearCountryIds:['tr'],controllerCountryId:'tr',tradeWeight:70,energyWeight:63,navalWeight:90,transitTimeWeight:86,disruptionIndex:7,securityRiskIndex:47,status:'open',note:'Bosporus et Dardanelles, Turquie; accès mer Noire–Méditerranée.'},
    {id:'red-sea',label:'Mer Rouge',kind:'sea',nearCountryIds:['eg','sa','ye','sd','er','dj'],tradeWeight:93,energyWeight:79,navalWeight:91,transitTimeWeight:92,disruptionIndex:17,securityRiskIndex:57,status:'open',note:'Entre Afrique du Nord-Est et péninsule Arabique.'},
    {id:'persian-gulf',label:'Golfe Persique',kind:'sea',nearCountryIds:['ir','iq','kw','sa','bh','qa','ae','om'],tradeWeight:82,energyWeight:99,navalWeight:94,transitTimeWeight:74,disruptionIndex:13,securityRiskIndex:62,status:'open',note:'Bassin énergétique entre Iran et péninsule Arabique.'},
    {id:'south-china-sea',label:'Mer de Chine méridionale',kind:'sea',nearCountryIds:['cn','vn','ph','my','bn','id','tw'],tradeWeight:99,energyWeight:67,navalWeight:99,transitTimeWeight:90,disruptionIndex:12,securityRiskIndex:67,status:'open',note:'Espace maritime contesté bordé par Chine et États d’Asie du Sud-Est.'},
    {id:'east-china-sea',label:'Mer de Chine orientale',kind:'sea',nearCountryIds:['cn','jp','kr','tw'],tradeWeight:91,energyWeight:52,navalWeight:96,transitTimeWeight:83,disruptionIndex:8,securityRiskIndex:57,status:'open',note:'Entre Chine, Japon, péninsule coréenne et Taïwan.'},
    {id:'taiwan',label:'Taïwan et détroit de Taïwan',kind:'region',nearCountryIds:['tw','cn','jp','ph'],controllerCountryId:'tw',tradeWeight:96,energyWeight:40,navalWeight:99,transitTimeWeight:86,disruptionIndex:10,securityRiskIndex:72,status:'open',note:'Détroit entre Taïwan et côte chinoise; enjeu critique pour semi-conducteurs et navigation.'},
    {id:'korean-peninsula',label:'Péninsule coréenne',kind:'region',nearCountryIds:['kr','kp','cn','jp','ru'],tradeWeight:75,energyWeight:30,navalWeight:87,transitTimeWeight:61,disruptionIndex:7,securityRiskIndex:78,status:'open',note:'Corée du Sud et Corée du Nord, au voisinage de Chine, Japon et Russie.'},
    {id:'baltic',label:'Mer Baltique',kind:'sea',nearCountryIds:['se','fi','ee','lv','lt','pl','de','dk','ru'],tradeWeight:68,energyWeight:45,navalWeight:89,transitTimeWeight:67,disruptionIndex:7,securityRiskIndex:60,status:'open',note:'Nord-Est européen; nombreux membres OTAN et accès russe.'},
    {id:'black-sea',label:'Mer Noire',kind:'sea',nearCountryIds:['ua','ru','tr','ro','bg','ge'],tradeWeight:65,energyWeight:49,navalWeight:91,transitTimeWeight:73,disruptionIndex:28,securityRiskIndex:82,status:'restricted',note:'Entre Europe orientale, Caucase et Turquie; accès via détroits turcs.'},
    {id:'arctic',label:'Arctique',kind:'region',nearCountryIds:['us','ca','dk','is','no','se','fi','ru'],tradeWeight:40,energyWeight:72,navalWeight:84,transitTimeWeight:54,disruptionIndex:9,securityRiskIndex:48,status:'open',note:'Région circumpolaire; routes, ressources, souveraineté et présence militaire.'},
    {id:'mediterranean',label:'Méditerranée',kind:'sea',nearCountryIds:['es','fr','it','gr','tr','eg','ly','dz','ma','il','lb','sy'],tradeWeight:88,energyWeight:61,navalWeight:88,transitTimeWeight:90,disruptionIndex:8,securityRiskIndex:42,status:'open',note:'Entre Europe, Afrique du Nord et Proche-Orient.'},
    {id:'horn-africa',label:'Corne de l’Afrique',kind:'region',nearCountryIds:['so','dj','er','et'],tradeWeight:62,energyWeight:38,navalWeight:85,transitTimeWeight:74,disruptionIndex:18,securityRiskIndex:70,status:'open',note:'Région autour Somalie, Djibouti, Érythrée et Éthiopie, proche Bab el-Mandeb.'}
  ] as any;
  const important=new Set(['us','cn','ru','fr','de','gb','jp','kr','in','br','mx','ca','ir','il','sa','tr','ua','tw','kp','au','id','za']);
  const bilateralEdges:any[]=[];
  const imp=countries.filter(c=>important.has(c.id));
  for(let i=0;i<imp.length;i++)for(let j=i+1;j<imp.length;j++){
    const a=imp[i],b=imp[j],sameAlliance=a.memberships.some(x=>b.memberships.includes(x))||a.allianceTags.some(x=>b.allianceTags.includes(x));
    const geo=a.region===b.region; const base=sameAlliance?72:geo?55:48; const dispute=a.disputes.length&&b.disputes.length?10:0;
    bilateralEdges.push({id:`edge-${a.id}-${b.id}`,countryAId:a.id,countryBId:b.id,diplomatic:Math.max(10,Math.min(90,base+(a.relation.diplomatic+b.relation.diplomatic-100)*.18)),economic:Math.max(10,Math.min(92,base+(a.economicIndex+b.economicIndex-100)*.16)),security:Math.max(8,Math.min(95,base+(a.militaryIndex+b.militaryIndex-100)*.15)),trust:Math.max(8,Math.min(92,base+(a.relation.trust+b.relation.trust-100)*.12)),tension:Math.max(5,Math.min(95,100-base+dispute)),tradeExposure:Math.max(5,Math.min(95,(a.usTradeIndex+b.usTradeIndex)/2)),securityGuarantee:sameAlliance&&a.memberships.includes('NATO')&&b.memberships.includes('NATO'),treatyTags:sameAlliance?['shared_organization']:[],disputeTags:[],memory:[],updatedAt:REF});
  }

  const agreements:InternationalAgreementState[]=[
    {id:'agreement-usmca',title:'United States–Mexico–Canada Agreement (USMCA)',form:'congressional_executive',parties:['us','mx','ca'],status:'active',effectiveAt:'2020-07-01T00:00:00.000Z',noticeMonths:6,senateAdviceConsentRequired:false,congressApprovalRequired:true,foreignRatificationRequired:true,clauses:[clause('usmca-trade','trade','Accès commercial nord-américain','Respecter engagements et mécanismes de l’accord','Respecter engagements et mécanismes de l’accord',0,1),clause('usmca-labor','security','Mécanismes de conformité et coopération','Faire fonctionner mécanismes prévus','Participer aux mécanismes prévus',0,2)],complianceUS:82,compliancePartners:79,legalBasis:'Accord commercial approuvé par le Congrès; revue périodique prévue.',source:'USTR/State — structure générale',confidence:.92,historyIds:[],flow:agreementFlow},
    {id:'agreement-nato-treaty',title:'Traité de l’Atlantique Nord',form:'treaty',parties:['us',...natoMembers.filter(x=>x!=='us')],organizationId:'nato',status:'active',signedAt:'1949-04-04T00:00:00.000Z',noticeMonths:12,senateAdviceConsentRequired:true,congressApprovalRequired:false,foreignRatificationRequired:true,clauses:[clause('nato-defense','defense','Défense collective','Assistance selon le traité et processus constitutionnels','Assistance selon le traité et processus nationaux',0,0)],complianceUS:88,compliancePartners:84,legalBasis:'Traité ratifié; Article 5 n’impose pas une réponse identique et automatique de chaque allié.',source:'NATO — traité / Article 5',confidence:.98,historyIds:[],flow:agreementFlow},
    {id:'agreement-israel-security',title:'Cadre de coopération de sécurité États-Unis–Israël',form:'memorandum',parties:['us','il'],status:'active',effectiveAt:'2019-10-01T00:00:00.000Z',noticeMonths:12,senateAdviceConsentRequired:false,congressApprovalRequired:true,foreignRatificationRequired:false,clauses:[clause('israel-security','defense','Coopération et assistance de sécurité','Financement sous crédits et droit applicables','Coopération et obligations convenues',3.8,1)],complianceUS:86,compliancePartners:84,legalBasis:'MOU + appropriations annuelles; ne remplace pas les pouvoirs du Congrès.',source:'State — coopération de sécurité (cadre public)',confidence:.88,historyIds:[],flow:agreementFlow},
    {id:'agreement-taiwan-framework',title:'Cadre de relations non officielles États-Unis–Taïwan',form:'political_commitment',parties:['us','tw'],status:'active',effectiveAt:'1979-01-01T00:00:00.000Z',noticeMonths:0,senateAdviceConsentRequired:false,congressApprovalRequired:false,foreignRatificationRequired:false,clauses:[clause('taiwan-science','science','Science, technologie et chaînes critiques','Coopération via AIT et autorités compétentes','Coopération via interlocuteurs non officiels',0,3),clause('taiwan-security','security','Cadre de sécurité non officiel','Agir conformément au Taiwan Relations Act et politiques applicables','Coordination non officielle',0,1)],complianceUS:82,compliancePartners:84,legalBasis:'Taiwan Relations Act + relations non officielles; ne pas traiter comme traité de reconnaissance.',source:'State/FAM — relations non officielles',confidence:.94,historyIds:[],flow:agreementFlow}
  ];
  const bureaus=[
    ['AF','African Affairs','regional'],['EAP','East Asian and Pacific Affairs','regional'],['EUR','European and Eurasian Affairs','regional'],['NEA','Near Eastern Affairs','regional'],['SCA','South and Central Asian Affairs','regional'],['WHA','Western Hemisphere Affairs','regional'],
    ['IO','International Organization Affairs','functional'],['EB','Economic and Business Affairs','functional'],['PM','Political-Military Affairs','functional'],['CA','Consular Affairs','functional'],['DS','Diplomatic Security','functional'],['INR','Intelligence and Research','functional'],['ECA','Educational and Cultural Affairs','functional'],['PRM','Population, Refugees, and Migration','functional']
  ].map((x,index)=>({id:x[0],label:x[1],type:x[2] as 'regional'|'functional',capacityIndex:70+(index%5)*3,workloadIndex:48+(index%6)*6,reportingQualityIndex:72+(index%4)*4,crisisLoadIndex:25+(index%7)*5,active:true}));
  return {
    referenceDate:REF,
    researchSources:[
      {id:'src-state-fam',label:'Department of State — FAM: regional bureaus / consular districts',url:'https://fam.state.gov/fam/02fam/02fam0460.html',checkedAt:REF},
      {id:'src-state-treaties',label:'Department of State — Office of Treaty Affairs',url:'https://www.state.gov/treaties-in-force',checkedAt:REF,note:'Procédures et distinctions traités/accords; URL de référence, seed abstrait.'},
      {id:'src-un-members',label:'United Nations — Member States',url:'https://www.un.org/about-us/member-states',checkedAt:REF},
      {id:'src-un-sc',label:'UN Security Council — Current Members',url:'https://main.un.org/securitycouncil/en/content/current-members',checkedAt:REF},
      {id:'src-nato-art5',label:'NATO — Collective defence and Article 5',url:'https://www.nato.int/en/what-we-do/introduction-to-nato/collective-defence-and-article-5',checkedAt:REF},
      {id:'src-eu-members',label:'European Union — EU countries',url:'https://european-union.europa.eu/principles-countries-history/eu-countries_en',checkedAt:REF},
      {id:'src-g20',label:'G20 — membership',url:'https://g20.org/',checkedAt:REF},
      {id:'src-asean',label:'ASEAN — Member States',url:'https://asean.org/member-states/',checkedAt:REF},
      {id:'src-au',label:'African Union — overview and membership',url:'https://www.au.int/en/overview',checkedAt:REF},
      {id:'src-oas',label:'Organization of American States — Member States',url:'https://www.oas.org/en/about/member_states.asp',checkedAt:REF},
      {id:'src-opec',label:'OPEC — official publications and Declaration of Cooperation',url:'https://www.opec.org/',checkedAt:REF},
      {id:'src-un-pop',label:'UN DESA — World Population Prospects 2024',url:'https://www.un.org/development/desa/pd/content/World-Population-Prospects-2024',checkedAt:REF,note:'Utilisé comme référence recommandée pour actualiser les populations; le seed embarqué conserve des repères historiques et les signale comme tels.'}
    ],
    stateDepartment:{secretaryActorId:'cabinet-actor-state',bureaus,diplomaticCorpsCapacityIndex:74,consularCapacityIndex:71,diplomaticSecurityIndex:79,protocolCapacityIndex:78,publicDiplomacyIndex:69,foreignAssistanceCoordinationIndex:72,treatyOfficeCapacityIndex:76,vacantAmbassadorPosts:countries.filter(c=>c.mission.chiefStatus==='vacant').length,closedOrLimitedPosts:countries.filter(c=>['closed','limited','no_relations'].includes(c.mission.status)).length,currentConsularCrises:2,updatedAt:REF},
    countries,diplomaticActions:[],travels:[],agreements,organizations,multilateralActions:[],coalitions:[],bilateralEdges,strategicLocations,disasters:[],conflicts:[],history:[],
    diplomaticCapacityIndex:74,allianceCohesionIndex:74,globalTradeAccessIndex:76,sanctionsPressureIndex:32,consularRiskIndex:31,softPowerIndex:68
  };
};
